var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginPatternBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438,
    height: 743,
    viewBox: "0 0 438 743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#004478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#003e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00335a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 743,
    rx: 25,
    transform: "translate(-0.667)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#a)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.667)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,743H437.623V0H0Z",
    fill: "#21409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.116,0l-.426.722,1.141,1.938L542.4,0Z",
    transform: "translate(-127.505)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.4,0l-2.711,4.6,1.146,1.949L547.7,0Z",
    transform: "translate(-128.214)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.694,0l-5.007,8.5,1.148,1.948L552.987,0Z",
    transform: "translate(-128.922)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.988,0l-7.3,12.391,1.147,1.937L558.276,0Z",
    transform: "translate(-129.632)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,0l-9.59,16.282,1.142,1.937L563.565,0Z",
    transform: "translate(-130.34)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.566,0,554.691,20.162l1.141,1.946L568.673.313V0Z",
    transform: "translate(-131.049)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.687,23.1l1.148,1.947L569.38,7.136V3.247Z",
    transform: "translate(-131.757 0.963)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.689,25.208l1.147,1.938,8.255-14.014V9.245Z",
    transform: "translate(-132.467 2.743)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.689,27.318l1.147,1.937L570.8,19.132V15.244Z",
    transform: "translate(-133.175 4.523)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.691,29.42l1.141,1.948,3.676-6.24V21.241Z",
    transform: "translate(-133.884 6.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.688,31.537l1.146,1.946,1.381-2.345V27.244Z",
    transform: "translate(-134.592 8.083)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.688,33.645l.237.4v-.8Z",
    transform: "translate(-135.301 9.863)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.378,574.665h2.292l2-3.395v-3.894Z",
    transform: "translate(-134.047 168.333)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.455,573.169h.882l-.442-.751Z",
    transform: "translate(-117.054 169.829)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.534,571.361l1.589,2.7h2.288l-2.73-4.636Z",
    transform: "translate(-117.546 168.94)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.534,568.367l3.877,6.583h2.3l-5.025-8.532Z",
    transform: "translate(-118.254 168.048)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.533,565.367,509.7,575.84h2.29l-7.317-12.419Z",
    transform: "translate(-118.963 167.159)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.534,562.361,515,576.728h2.286l-9.607-16.3Z",
    transform: "translate(-119.672 166.27)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.532,559.367l10.752,18.253h2.294l-11.9-20.2Z",
    transform: "translate(-120.38 165.378)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.532,556.371l13.043,22.137h2.293l-14.188-24.087Z",
    transform: "translate(-121.089 164.489)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.535,553.365,530.868,579.4h2.291l-16.478-27.981Z",
    transform: "translate(-121.798 163.598)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.533,550.369l17.624,29.921h2.293l-18.775-31.869Z",
    transform: "translate(-122.507 162.709)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.532,547.361l19.923,33.818h2.285L522.68,545.423Z",
    transform: "translate(-123.215 161.82)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.531,544.366l22.213,37.7h2.289l-23.354-39.651Z",
    transform: "translate(-123.924 160.929)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.534,541.369l24.5,41.589h2.294l-25.644-43.536Z",
    transform: "translate(-124.633 160.039)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.533,538.366l26.3,44.655,1.147-1.94-26.307-44.665Z",
    transform: "translate(-125.342 159.148)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.98,578.074l-26.3-44.653-1.148,1.948,26.307,44.651Z",
    transform: "translate(-126.05 158.259)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.533,532.362l26.305,44.661,1.143-1.947-26.3-44.652Z",
    transform: "translate(-126.759 157.37)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.532,529.367l25.559,43.393v-3.894L540.68,527.418Z",
    transform: "translate(-127.468 156.478)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.533,526.368,565.8,565.875v-3.894l-22.128-37.56Z",
    transform: "translate(-128.177 155.589)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.529,523.363l20.979,35.608v-3.877l-19.831-33.669Z",
    transform: "translate(-128.885 154.7)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.531,520.368l18.688,31.72V548.2l-17.54-29.778Z",
    transform: "translate(-129.594 153.808)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.531,517.372l16.395,27.835v-3.9l-15.247-25.886Z",
    transform: "translate(-130.303 152.919)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.533,514.365l14.1,23.945v-3.887l-12.961-22Z",
    transform: "translate(-131.012 152.028)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.531,511.369l11.813,20.055V527.53l-10.666-18.11Z",
    transform: "translate(-131.72 151.138)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.53,508.362l9.522,16.165v-3.885l-8.375-14.218Z",
    transform: "translate(-132.429 150.249)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.531,505.367l7.232,12.278v-3.9L564.68,503.42Z",
    transform: "translate(-133.138 149.358)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.533,502.369l4.938,8.385v-3.887l-3.8-6.444Z",
    transform: "translate(-133.847 148.469)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.534,499.363l2.647,4.495v-3.876l-1.506-2.556Z",
    transform: "translate(-134.556 147.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.53,496.062l.357.607v-1.215Z",
    transform: "translate(-135.264 146.994)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.749,0,547.9,137.773v-3.889L469.042,0Z",
    transform: "translate(-110.273)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.751,0l76.563,129.988V126.1L475.044,0Z",
    transform: "translate(-111.691)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.749,0l71.982,122.211v-3.892L481.041,0Z",
    transform: "translate(-113.108)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.748,0l67.4,114.433v-3.884L487.037,0Z",
    transform: "translate(-114.525)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.754,0l62.815,106.645v-3.88L493.041,0Z",
    transform: "translate(-115.944)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.748,0l58.235,98.875v-3.9L499.045,0Z",
    transform: "translate(-117.36)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.749,0,556.4,91.091v-3.88L505.035,0Z",
    transform: "translate(-118.778)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.746,0l49.072,83.315V79.421L511.039,0Z",
    transform: "translate(-120.195)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.748,0l44.488,75.532v-3.89L517.04,0Z",
    transform: "translate(-121.612)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.753,0l39.9,67.748V63.861L523.042,0Z",
    transform: "translate(-123.031)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.75,0l35.323,59.972V56.085L529.039,0Z",
    transform: "translate(-124.448)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.747,0,563.49,52.2v-3.89L535.038,0Z",
    transform: "translate(-125.865)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.343,97.126l-26.3,44.661-1.148-1.947L553.2,95.188Z",
    transform: "translate(-124.482 28.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.343,100.127l-26.3,44.662-1.148-1.947L556.2,98.19Z",
    transform: "translate(-125.191 29.132)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.344,103.128,534.038,147.78l-1.143-1.937,26.3-44.653Z",
    transform: "translate(-125.9 30.022)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.341,106.131l-26.3,44.654-1.147-1.939L562.2,104.184Z",
    transform: "translate(-126.608 30.91)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.895,151.74l1.148,1.946,24.9-42.284v-3.878Z",
    transform: "translate(-127.317 31.901)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.9,153.853l1.147,1.947,22.609-38.389v-3.89Z",
    transform: "translate(-128.026 33.68)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.9,155.964l1.143,1.937,20.32-34.493v-3.885Z",
    transform: "translate(-128.735 35.461)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.893,158.075l1.146,1.937,18.029-30.606v-3.887Z",
    transform: "translate(-129.443 37.24)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.892,160.178l1.148,1.947,15.734-26.718v-3.886Z",
    transform: "translate(-130.152 39.021)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.894,162.292l1.147,1.946,13.443-22.83v-3.884Z",
    transform: "translate(-130.861 40.802)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.895,164.4l1.142,1.939L569.2,147.4V143.52Z",
    transform: "translate(-131.57 42.58)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.9,166.514l1.141,1.938L569.9,153.4v-3.878Z",
    transform: "translate(-132.279 44.362)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.894,168.619l1.147,1.946,6.571-11.154v-3.893Z",
    transform: "translate(-132.987 46.14)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.893,170.731l1.146,1.95,4.279-7.268v-3.891Z",
    transform: "translate(-133.696 47.921)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.893,172.843l1.142,1.94,1.993-3.384v-3.877Z",
    transform: "translate(-134.405 49.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.9,174.954l.843,1.431v-2.863Z",
    transform: "translate(-135.114 51.482)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.247,0l-.426.722,1.148,1.938L400.536,0Z",
    transform: "translate(-93.988)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.535,0l-2.711,4.6,1.146,1.949L405.831,0Z",
    transform: "translate(-94.697)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.83,0l-5.007,8.5,1.147,1.948L411.122,0Z",
    transform: "translate(-95.406)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.123,0l-7.3,12.391,1.141,1.937L416.407,0Z",
    transform: "translate(-96.115)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.415,0l-9.589,16.282,1.142,1.937L421.7,0Z",
    transform: "translate(-96.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7,0,412.822,20.162l1.147,1.946L426.993,0Z",
    transform: "translate(-97.532)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,0,415.823,24.058l1.148,1.95L432.286,0Z",
    transform: "translate(-98.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.288,0,418.825,27.951l1.142,1.937L437.576,0Z",
    transform: "translate(-98.95)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.575,0l-18.75,31.84,1.142,1.94L442.866,0Z",
    transform: "translate(-99.659)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.868,0,424.822,35.722l1.148,1.947L448.157,0Z",
    transform: "translate(-100.367)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.165,0l-23.34,39.619,1.147,1.946L453.45,0Z",
    transform: "translate(-101.076)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.45,0,430.823,43.51l1.148,1.938L458.271.793,457.8,0Z",
    transform: "translate(-101.785)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.273,4.06,434.967,48.712l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-102.494 0.627)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.27,7.059l-26.3,44.653-1.148-1.947L463.129,5.112Z",
    transform: "translate(-103.202 1.517)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.271,10.055l-26.3,44.661-1.148-1.947L466.13,8.117Z",
    transform: "translate(-103.911 2.408)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.272,13.055l-26.3,44.652-1.147-1.937,26.3-44.652Z",
    transform: "translate(-104.62 3.299)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.272,16.056,446.966,60.711l-1.143-1.94,26.3-44.653Z",
    transform: "translate(-105.329 4.189)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.273,19.058,449.967,63.71l-1.143-1.947,26.3-44.643Z",
    transform: "translate(-106.038 5.079)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.271,22.06l-26.3,44.653-1.148-1.947L478.13,20.114Z",
    transform: "translate(-106.746 5.967)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.272,25.056l-26.3,44.661-1.148-1.946,26.3-44.654Z",
    transform: "translate(-107.455 6.859)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.272,28.055,458.966,72.708l-1.142-1.938,26.3-44.653Z",
    transform: "translate(-108.164 7.749)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.269,31.057l-26.3,44.653-1.147-1.938,26.307-44.653Z",
    transform: "translate(-108.872 8.639)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.271,34.06l-26.3,44.654-1.146-1.948,26.307-44.653Z",
    transform: "translate(-109.581 9.527)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271,37.055l-26.3,44.661-1.148-1.946,26.3-44.653Z",
    transform: "translate(-110.29 10.419)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.271,40.055,470.966,84.708l-1.143-1.938,26.3-44.652Z",
    transform: "translate(-110.999 11.309)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.269,43.058l-26.3,44.654-1.146-1.939,26.307-44.662Z",
    transform: "translate(-111.707 12.197)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.27,46.059l-26.3,44.652-1.148-1.946,26.307-44.653Z",
    transform: "translate(-112.416 13.087)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.27,49.053,479.964,93.716l-1.143-1.946,26.307-44.653Z",
    transform: "translate(-113.125 13.979)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.271,52.055,482.965,96.707l-1.143-1.937,26.3-44.653Z",
    transform: "translate(-113.834 14.869)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.273,55.058,485.967,99.711l-1.143-1.938,26.3-44.661Z",
    transform: "translate(-114.543 15.757)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.27,58.059l-26.3,44.655-1.15-1.95,26.307-44.653Z",
    transform: "translate(-115.251 16.648)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.27,61.055l-26.3,44.661-1.146-1.947,26.307-44.653Z",
    transform: "translate(-115.96 17.539)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.271,64.055l-26.3,44.652-1.146-1.937,26.3-44.654Z",
    transform: "translate(-116.669 18.429)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.273,67.057,497.965,111.71l-1.141-1.938,26.3-44.661Z",
    transform: "translate(-117.378 19.317)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.27,70.058l-26.3,44.654-1.148-1.948,26.307-44.652Z",
    transform: "translate(-118.086 20.208)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.269,73.054l-26.3,44.661-1.148-1.947,26.307-44.652Z",
    transform: "translate(-118.795 21.099)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.27,76.054l-26.3,44.654-1.148-1.938,26.3-44.652Z",
    transform: "translate(-119.504 21.989)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.272,79.057l-26.305,44.652-1.143-1.938,26.3-44.662Z",
    transform: "translate(-120.213 22.877)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.269,82.057l-26.3,44.653-1.147-1.947,26.307-44.652Z",
    transform: "translate(-120.921 23.768)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.269,85.053l-26.3,44.661-1.148-1.946,26.307-44.653Z",
    transform: "translate(-121.63 24.659)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.27,88.054l-26.3,44.662-1.147-1.948,26.3-44.653Z",
    transform: "translate(-122.339 25.549)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.27,91.055l-26.307,44.654-1.141-1.939,26.3-44.654Z",
    transform: "translate(-123.047 26.44)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.268,94.057l-26.3,44.653-1.148-1.937,26.307-44.662Z",
    transform: "translate(-123.756 27.328)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.512,616.755H427.8l110.35-187.35v-3.9Z",
    transform: "translate(-100.53 126.243)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.515,614.974h2.295L539.573,435.408v-3.9Z",
    transform: "translate(-101.948 128.024)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.512,613.2H439.8L540.99,441.4v-3.889Z",
    transform: "translate(-103.365 129.803)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.509,611.416H445.8L542.4,447.4v-3.894Z",
    transform: "translate(-104.782 131.582)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.509,609.635h2.3l92.017-156.228v-3.9Z",
    transform: "translate(-106.199 133.363)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.509,607.855H457.8L545.242,459.4v-3.9Z",
    transform: "translate(-107.617 135.143)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.511,606.074h2.295L546.658,465.4v-3.894Z",
    transform: "translate(-109.035 136.924)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.508,604.3H469.8l78.276-132.9v-3.89Z",
    transform: "translate(-110.452 138.703)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.512,602.514H475.8L549.494,477.4V473.51Z",
    transform: "translate(-111.87 140.484)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.514,600.733H481.8L550.911,483.4v-3.886Z",
    transform: "translate(-113.288 142.265)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.511,598.954H487.8L552.328,489.4v-3.89Z",
    transform: "translate(-114.705 144.044)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.509,597.175H493.8L553.745,495.4v-3.892Z",
    transform: "translate(-116.122 145.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.187,515l-26.3-44.652-1.147,1.938,26.308,44.652Z",
    transform: "translate(-107.435 139.547)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.188,512l-26.3-44.652-1.148,1.947,26.3,44.652Z",
    transform: "translate(-108.144 138.656)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.189,509l-26.306-44.651-1.144,1.946,26.3,44.653Z",
    transform: "translate(-108.853 137.767)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.185,506.008l-26.3-44.662-1.148,1.947,26.307,44.653Z",
    transform: "translate(-109.561 136.875)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.187,503l-26.3-44.653-1.147,1.947,26.307,44.653Z",
    transform: "translate(-110.27 135.986)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.188,500.005l-26.3-44.654-1.148,1.937,26.3,44.662Z",
    transform: "translate(-110.979 135.097)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.189,497l-26.305-44.653-1.143,1.947,26.3,44.653Z",
    transform: "translate(-111.688 134.205)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.186,494l-26.3-44.654-1.147,1.948,26.308,44.653Z",
    transform: "translate(-112.396 133.316)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.186,491.005l-26.3-44.653-1.146,1.938,26.307,44.653Z",
    transform: "translate(-113.105 132.427)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.188,488l-26.3-44.653-1.147,1.947,26.3,44.652Z",
    transform: "translate(-113.814 131.535)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.187,485l-26.305-44.653-1.143,1.947,26.3,44.653Z",
    transform: "translate(-114.523 130.646)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.185,482.008l-26.3-44.661-1.148,1.946,26.307,44.652Z",
    transform: "translate(-115.231 129.755)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.186,479l-26.3-44.653-1.147,1.948,26.307,44.652Z",
    transform: "translate(-115.94 128.866)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.187,476l-26.3-44.652-1.146,1.937,26.307,44.662Z",
    transform: "translate(-116.649 127.977)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.187,473l-26.306-44.653-1.142,1.948,26.306,44.652Z",
    transform: "translate(-117.358 127.085)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.184,470l-26.3-44.653-1.146,1.947,26.307,44.653Z",
    transform: "translate(-118.066 126.196)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.186,467l-26.3-44.651-1.147,1.937,26.307,44.653Z",
    transform: "translate(-118.775 125.307)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.185,464l-26.3-44.655-1.146,1.95,26.307,44.654Z",
    transform: "translate(-119.484 124.415)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.186,461l-26.3-44.653-1.148,1.939,26.3,44.661Z",
    transform: "translate(-120.193 123.526)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.188,458.01l-26.305-44.662-1.143,1.946,26.3,44.653Z",
    transform: "translate(-120.902 122.635)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.185,455l-26.3-44.652-1.146,1.946,26.307,44.653Z",
    transform: "translate(-121.61 121.746)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.185,452.006l-26.3-44.654-1.146,1.938,26.307,44.661Z",
    transform: "translate(-122.319 120.856)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.186,449l-26.3-44.652-1.147,1.947,26.3,44.652Z",
    transform: "translate(-123.028 119.965)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.188,446l-26.307-44.653-1.141,1.947,26.3,44.652Z",
    transform: "translate(-123.737 119.076)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.185,443.009l-26.3-44.662-1.148,1.947,26.307,44.652Z",
    transform: "translate(-124.445 118.184)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.185,440l-26.3-44.654-1.148,1.948,26.307,44.652Z",
    transform: "translate(-125.154 117.295)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.186,437l-26.3-44.652-1.148,1.937,26.3,44.662Z",
    transform: "translate(-125.863 116.406)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.187,434.01l-26.305-44.662-1.143,1.948,26.3,44.652Z",
    transform: "translate(-126.572 115.514)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.734,388.3,564.9,432.718v-3.89l-25.02-42.479Z",
    transform: "translate(-127.279 114.625)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.738,385.292l23.876,40.53v-3.881l-22.729-38.59Z",
    transform: "translate(-127.989 113.735)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.737,382.3l21.585,36.639V415.05l-20.444-34.7Z",
    transform: "translate(-128.698 112.845)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.739,379.3l19.291,32.755v-3.891l-18.15-30.81Z",
    transform: "translate(-129.407 111.955)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.736,376.295l17,28.861v-3.883l-15.856-26.927Z",
    transform: "translate(-130.115 111.064)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.736,373.3l14.711,24.972v-3.89l-13.565-23.03Z",
    transform: "translate(-130.824 110.175)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.737,370.292l12.421,21.085V387.49l-11.273-19.136Z",
    transform: "translate(-131.533 109.286)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.739,367.3l10.126,17.194V380.6L560.88,365.35Z",
    transform: "translate(-132.242 108.394)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.734,364.3l7.838,13.307v-3.894l-6.692-11.362Z",
    transform: "translate(-132.95 107.505)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.737,361.292l5.547,9.416v-3.885l-4.4-7.468Z",
    transform: "translate(-133.659 106.616)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.735,358.3l3.255,5.529v-3.9l-2.108-3.579Z",
    transform: "translate(-134.367 105.724)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.738,355.232l.964,1.636v-3.281Z",
    transform: "translate(-135.077 104.904)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.591,573.169h.884l-.442-.751Z",
    transform: "translate(-83.538 169.829)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.669,571.361l1.588,2.7h2.289l-2.73-4.636Z",
    transform: "translate(-84.029 168.94)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.67,568.367l3.877,6.583h2.291l-5.026-8.532Z",
    transform: "translate(-84.738 168.048)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.666,565.367l6.169,10.472h2.294l-7.315-12.419Z",
    transform: "translate(-85.446 167.159)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.665,562.361l8.464,14.367h2.287l-9.6-16.3Z",
    transform: "translate(-86.155 166.27)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.669,559.367l10.752,18.253h2.294l-11.9-20.2Z",
    transform: "translate(-86.864 165.378)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.668,556.371l13.039,22.137H386l-14.188-24.087Z",
    transform: "translate(-87.573 164.489)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.669,553.365,389,579.4h2.29L374.81,551.418Z",
    transform: "translate(-88.282 163.598)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.666,550.369l17.626,29.921h2.292l-18.771-31.869Z",
    transform: "translate(-88.99 162.709)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.666,547.361l19.923,33.818h2.285l-21.062-35.755Z",
    transform: "translate(-89.699 161.82)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.667,544.366l22.208,37.7h2.294l-23.355-39.651Z",
    transform: "translate(-90.408 160.929)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.669,541.369l24.5,41.589h2.3l-25.65-43.536Z",
    transform: "translate(-91.117 160.039)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.667,538.366l26.306,44.655,1.142-1.94-26.3-44.665Z",
    transform: "translate(-91.825 159.148)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.114,578.074l-26.3-44.653-1.147,1.948,26.307,44.651Z",
    transform: "translate(-92.534 158.259)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.116,575.076l-26.3-44.652-1.148,1.938,26.3,44.662Z",
    transform: "translate(-93.243 157.37)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.117,572.072,398.81,527.419l-1.143,1.948,26.3,44.651Z",
    transform: "translate(-93.951 156.478)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.113,569.074l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-94.66 155.589)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.114,566.077l-26.3-44.652-1.146,1.937,26.307,44.653Z",
    transform: "translate(-95.369 154.7)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.115,563.073,407.81,518.42l-1.143,1.947,26.3,44.654Z",
    transform: "translate(-96.078 153.808)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.116,560.077l-26.306-44.653-1.143,1.947,26.3,44.652Z",
    transform: "translate(-96.787 152.919)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.116,557.081,413.81,512.419l-1.143,1.946,26.3,44.654Z",
    transform: "translate(-97.495 152.028)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.114,554.074l-26.3-44.653-1.148,1.947,26.307,44.653Z",
    transform: "translate(-98.204 151.139)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.115,551.078l-26.3-44.654-1.147,1.938,26.3,44.653Z",
    transform: "translate(-98.913 150.249)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.115,548.073l-26.306-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-99.621 149.358)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.116,545.075,425.81,500.423l-1.142,1.946,26.3,44.653Z",
    transform: "translate(-100.33 148.469)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.114,542.078l-26.3-44.653-1.146,1.938,26.307,44.653Z",
    transform: "translate(-101.039 147.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.115,539.074l-26.3-44.653-1.148,1.948,26.307,44.652Z",
    transform: "translate(-101.748 146.688)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.114,536.076l-26.305-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-102.456 145.799)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.116,533.081,437.81,488.419l-1.143,1.947,26.3,44.653Z",
    transform: "translate(-103.165 144.907)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.114,530.075l-26.3-44.653-1.146,1.948,26.306,44.651Z",
    transform: "translate(-103.874 144.018)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.114,527.078l-26.3-44.652-1.148,1.937,26.307,44.653Z",
    transform: "translate(-104.583 143.129)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.116,524.074l-26.3-44.653-1.147,1.948,26.3,44.652Z",
    transform: "translate(-105.292 142.238)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.115,521.076l-26.306-44.653-1.142,1.947,26.3,44.654Z",
    transform: "translate(-106.001 141.348)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.113,518.081l-26.3-44.662-1.147,1.947,26.307,44.652Z",
    transform: "translate(-106.709 140.457)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.882,0l189.5,321.728v-3.887L327.175,0Z",
    transform: "translate(-76.756)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.886,0,515.8,313.945v-3.89L333.176,0Z",
    transform: "translate(-78.174)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.885,0,517.216,306.168v-3.9L339.177,0Z",
    transform: "translate(-79.591)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.882,0,518.631,298.384V294.5L345.175,0Z",
    transform: "translate(-81.008)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.883,0,520.051,290.606v-3.887L351.176,0Z",
    transform: "translate(-82.426)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.882,0,521.468,282.832v-3.906L357.18,0Z",
    transform: "translate(-83.843)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.878,0,522.883,275.056v-3.9L363.173,0Z",
    transform: "translate(-85.26)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.881,0,524.3,267.27v-3.894L369.174,0Z",
    transform: "translate(-86.678)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.883,0,525.721,259.489V255.6L375.175,0Z",
    transform: "translate(-88.096)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.885,0,527.137,251.7v-3.888L381.175,0Z",
    transform: "translate(-89.514)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.879,0,528.553,243.937v-3.9L387.177,0Z",
    transform: "translate(-90.93)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.879,0,529.971,236.15v-3.887L393.171,0Z",
    transform: "translate(-92.348)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.478,97.126l-26.3,44.661-1.147-1.947,26.3-44.652Z",
    transform: "translate(-90.966 28.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,100.127l-26.306,44.662-1.143-1.947,26.3-44.652Z",
    transform: "translate(-91.675 29.132)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.476,103.128l-26.3,44.652-1.146-1.937,26.307-44.653Z",
    transform: "translate(-92.383 30.022)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.477,106.131l-26.3,44.654-1.147-1.939,26.307-44.661Z",
    transform: "translate(-93.092 30.91)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.478,109.126l-26.3,44.661-1.148-1.946,26.3-44.653Z",
    transform: "translate(-93.801 31.801)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.479,112.126l-26.306,44.662-1.143-1.947,26.3-44.653Z",
    transform: "translate(-94.51 32.692)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.475,115.127l-26.3,44.653-1.146-1.937,26.307-44.654Z",
    transform: "translate(-95.218 33.582)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.476,118.13l-26.3,44.655-1.148-1.94,26.308-44.662Z",
    transform: "translate(-95.927 34.47)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.477,121.131l-26.3,44.654-1.148-1.947,26.3-44.653Z",
    transform: "translate(-96.636 35.36)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.479,124.127l-26.3,44.661-1.147-1.946,26.3-44.653Z",
    transform: "translate(-97.345 36.252)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.478,127.126,416.173,171.78l-1.143-1.938,26.3-44.652Z",
    transform: "translate(-98.054 37.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.476,130.128l-26.3,44.653-1.147-1.939,26.307-44.652Z",
    transform: "translate(-98.762 38.032)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.477,133.131l-26.3,44.652-1.149-1.946,26.307-44.653Z",
    transform: "translate(-99.47 38.92)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.477,136.125l-26.306,44.662-1.143-1.946,26.307-44.653Z",
    transform: "translate(-100.179 39.812)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.478,139.127l-26.306,44.654-1.142-1.94,26.3-44.651Z",
    transform: "translate(-100.889 40.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.476,142.13l-26.3,44.653-1.147-1.938,26.307-44.662Z",
    transform: "translate(-101.597 41.59)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.477,145.13l-26.3,44.654-1.147-1.95,26.307-44.652Z",
    transform: "translate(-102.306 42.481)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.478,148.126l-26.3,44.662-1.147-1.947,26.3-44.654Z",
    transform: "translate(-103.015 43.372)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.478,151.127l-26.306,44.654-1.143-1.94,26.3-44.653Z",
    transform: "translate(-103.724 44.262)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.475,154.126l-26.3,44.654-1.148-1.938,26.307-44.653Z",
    transform: "translate(-104.432 45.153)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.476,157.131l-26.3,44.653-1.15-1.938,26.308-44.662Z",
    transform: "translate(-105.14 46.041)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.476,160.125l-26.3,44.662-1.148-1.946,26.3-44.653Z",
    transform: "translate(-105.85 46.932)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.478,163.125l-26.306,44.653-1.143-1.938,26.3-44.653Z",
    transform: "translate(-106.559 47.822)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.475,166.128l-26.3,44.655-1.146-1.94,26.307-44.662Z",
    transform: "translate(-107.267 48.71)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.475,169.129l-26.3,44.653-1.146-1.938,26.307-44.662Z",
    transform: "translate(-107.975 49.601)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.476,172.124l-26.3,44.661-1.147-1.946,26.307-44.652Z",
    transform: "translate(-108.684 50.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.477,175.125l-26.305,44.662-1.143-1.947,26.3-44.652Z",
    transform: "translate(-109.394 51.383)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.475,178.129l-26.3,44.652-1.146-1.938,26.307-44.662Z",
    transform: "translate(-110.102 52.271)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.476,181.128l-26.3,44.653-1.147-1.938,26.307-44.661Z",
    transform: "translate(-110.811 53.161)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.476,184.125l-26.3,44.661-1.147-1.947,26.307-44.654Z",
    transform: "translate(-111.52 54.052)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.477,187.125l-26.306,44.661-1.142-1.947,26.3-44.653Z",
    transform: "translate(-112.229 54.942)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.474,190.125l-26.3,44.654-1.147-1.937,26.307-44.654Z",
    transform: "translate(-112.936 55.833)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.474,193.129l-26.3,44.653-1.147-1.938,26.307-44.662Z",
    transform: "translate(-113.645 56.721)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.475,196.129l-26.3,44.653-1.146-1.947,26.307-44.653Z",
    transform: "translate(-114.355 57.611)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.477,199.124l-26.306,44.661-1.143-1.947,26.3-44.651Z",
    transform: "translate(-115.064 58.503)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.478,202.125l-26.305,44.653-1.143-1.938,26.3-44.653Z",
    transform: "translate(-115.773 59.393)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.474,205.128l-26.3,44.652-1.148-1.937,26.307-44.662Z",
    transform: "translate(-116.48 60.281)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.475,208.129l-26.3,44.653-1.148-1.948,26.307-44.651Z",
    transform: "translate(-117.19 61.172)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.476,211.124l-26.3,44.662-1.148-1.947,26.3-44.653Z",
    transform: "translate(-117.899 62.063)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.477,214.125l-26.306,44.652-1.144-1.937,26.3-44.653Z",
    transform: "translate(-118.607 62.953)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.473,217.128l-26.3,44.653-1.146-1.938,26.307-44.662Z",
    transform: "translate(-119.316 63.841)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.475,220.128l-26.3,44.653-1.148-1.947,26.308-44.652Z",
    transform: "translate(-120.024 64.731)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.474,223.124l-26.3,44.662-1.148-1.947,26.3-44.653Z",
    transform: "translate(-120.733 65.623)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.475,226.125l-26.307,44.653-1.142-1.938,26.3-44.653Z",
    transform: "translate(-121.442 66.513)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.473,229.125l-26.3,44.654-1.146-1.938,26.307-44.652Z",
    transform: "translate(-122.151 67.404)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.475,232.127l-26.3,44.653-1.146-1.938,26.307-44.662Z",
    transform: "translate(-122.86 68.291)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.476,235.122l-26.3,44.662-1.147-1.947,26.3-44.652Z",
    transform: "translate(-123.569 69.183)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.475,238.124l-26.306,44.653-1.143-1.939,26.3-44.653Z",
    transform: "translate(-124.277 70.073)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.473,241.125l-26.3,44.651-1.147-1.937,26.307-44.652Z",
    transform: "translate(-124.985 70.964)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.474,244.127l-26.3,44.653-1.148-1.937,26.307-44.662Z",
    transform: "translate(-125.695 71.852)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.473,247.129l-26.3,44.652-1.148-1.947,26.3-44.653Z",
    transform: "translate(-126.403 72.742)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.027,292.839l1.143,1.95,25.566-43.409v-2.505l-.406-.69Z",
    transform: "translate(-127.112 73.633)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.028,295.107l1.141,1.94,23.278-39.511v-3.885Z",
    transform: "translate(-127.821 75.255)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.026,297.22l1.148,1.947,20.981-35.628v-3.89Z",
    transform: "translate(-128.53 77.034)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.025,299.324l1.148,1.947,18.69-31.73v-3.9Z",
    transform: "translate(-129.238 78.813)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.027,301.437l1.141,1.94,16.4-27.845v-3.883Z",
    transform: "translate(-129.947 80.595)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.024,303.548l1.147,1.947,14.109-23.958v-3.887Z",
    transform: "translate(-130.656 82.375)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.384,0l-.426.722L257.1,2.66,258.673,0Z",
    transform: "translate(-60.472)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.672,0l-2.711,4.6,1.146,1.949L263.967,0Z",
    transform: "translate(-61.181)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.966,0l-5.006,8.5,1.142,1.948L269.256,0Z",
    transform: "translate(-61.89)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.258,0l-7.3,12.391,1.148,1.937L274.544,0Z",
    transform: "translate(-62.598)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.549,0l-9.592,16.282,1.148,1.937L279.837,0Z",
    transform: "translate(-63.307)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.837,0,270.959,20.162l1.147,1.946L285.13,0Z",
    transform: "translate(-64.016)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,0,273.958,24.058l1.148,1.95L290.421,0Z",
    transform: "translate(-64.724)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.423,0,276.956,27.951l1.148,1.937L295.71,0Z",
    transform: "translate(-65.433)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.713,0,279.959,31.84l1.147,1.94L301,0Z",
    transform: "translate(-66.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,0,282.957,35.722l1.147,1.947L306.292,0Z",
    transform: "translate(-66.85)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.293,0,285.958,39.619l1.148,1.946L311.583,0Z",
    transform: "translate(-67.559)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.587,0,288.96,43.51l1.143,1.938L316.408.793,315.938,0Z",
    transform: "translate(-68.269)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.405,4.06,293.1,48.712l-1.148-1.938L318.264,2.112Z",
    transform: "translate(-68.977 0.627)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.406,7.059,296.1,51.712l-1.147-1.947L321.265,5.112Z",
    transform: "translate(-69.686 1.517)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.406,10.055,299.1,54.717l-1.147-1.947,26.3-44.653Z",
    transform: "translate(-70.394 2.408)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.407,13.055,302.1,57.707l-1.143-1.937,26.3-44.652Z",
    transform: "translate(-71.103 3.299)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.405,16.056,305.1,60.711l-1.147-1.94,26.307-44.653Z",
    transform: "translate(-71.812 4.189)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,19.058,308.1,63.71l-1.148-1.947,26.307-44.643Z",
    transform: "translate(-72.52 5.079)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.405,22.06,311.1,66.713l-1.147-1.947,26.3-44.652Z",
    transform: "translate(-73.229 5.967)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.407,25.056,314.1,69.718l-1.143-1.946,26.3-44.654Z",
    transform: "translate(-73.939 6.859)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,28.055,317.1,72.708l-1.147-1.938,26.307-44.653Z",
    transform: "translate(-74.647 7.749)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.406,31.057,320.1,75.709l-1.146-1.938,26.307-44.653Z",
    transform: "translate(-75.356 8.639)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.405,34.06,323.1,78.713l-1.147-1.948,26.307-44.653Z",
    transform: "translate(-76.065 9.527)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.407,37.055,326.1,81.716l-1.143-1.946,26.3-44.653Z",
    transform: "translate(-76.774 10.419)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4,40.055,329.1,84.708l-1.146-1.938,26.307-44.652Z",
    transform: "translate(-77.481 11.309)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,43.058,332.1,87.712l-1.146-1.939,26.307-44.662Z",
    transform: "translate(-78.19 12.197)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.405,46.059l-26.3,44.652-1.148-1.946,26.307-44.653Z",
    transform: "translate(-78.899 13.087)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.406,49.053,338.1,93.716l-1.142-1.946,26.3-44.653Z",
    transform: "translate(-79.609 13.979)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.406,52.055,341.1,96.707l-1.143-1.937,26.3-44.653Z",
    transform: "translate(-80.317 14.869)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,55.058,344.1,99.711l-1.147-1.938,26.307-44.661Z",
    transform: "translate(-81.025 15.757)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,58.059l-26.3,44.655-1.147-1.95,26.307-44.653Z",
    transform: "translate(-81.735 16.648)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.406,61.055,350.1,105.716l-1.143-1.947,26.3-44.653Z",
    transform: "translate(-82.444 17.539)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.407,64.055,353.1,108.707l-1.144-1.937,26.3-44.654Z",
    transform: "translate(-83.152 18.429)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,67.057,356.1,111.71l-1.147-1.938L381.262,65.11Z",
    transform: "translate(-83.86 19.317)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.4,70.058l-26.3,44.654-1.146-1.948,26.306-44.652Z",
    transform: "translate(-84.57 20.208)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,73.054l-26.3,44.661-1.148-1.947,26.3-44.652Z",
    transform: "translate(-85.278 21.099)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.405,76.054,365.1,120.707l-1.143-1.938,26.3-44.652Z",
    transform: "translate(-85.987 21.989)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.4,79.057l-26.3,44.652-1.147-1.938,26.307-44.662Z",
    transform: "translate(-86.695 22.877)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,82.057,371.1,126.71l-1.146-1.947,26.307-44.652Z",
    transform: "translate(-87.405 23.768)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.405,85.053l-26.3,44.661-1.147-1.946,26.3-44.653Z",
    transform: "translate(-88.114 24.659)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.405,88.054,377.1,132.717l-1.142-1.948,26.3-44.653Z",
    transform: "translate(-88.822 25.549)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,91.055l-26.3,44.654-1.147-1.939,26.307-44.654Z",
    transform: "translate(-89.53 26.44)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.4,94.057,383.1,138.71l-1.147-1.937,26.307-44.662Z",
    transform: "translate(-90.24 27.328)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.646,658.845h2.292l218.7-371.306v-3.9Z",
    transform: "translate(-67.013 84.153)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.647,657.064h2.3L506.054,293.543v-3.9Z",
    transform: "translate(-68.431 85.934)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.644,655.285h2.291L507.471,299.531v-3.887Z",
    transform: "translate(-69.848 87.714)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.645,653.506h2.29L508.889,305.533v-3.9Z",
    transform: "translate(-71.266 89.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.644,651.724h2.3L510.306,311.543v-3.9Z",
    transform: "translate(-72.683 91.274)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.641,649.945h2.3l195.785-332.4v-3.9Z",
    transform: "translate(-74.1 93.053)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.648,648.164h2.29l191.2-324.627v-3.894Z",
    transform: "translate(-75.519 94.834)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.647,646.384h2.289l186.624-316.85v-3.887Z",
    transform: "translate(-76.936 96.615)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.647,644.6h2.292L515.977,335.54v-3.9Z",
    transform: "translate(-78.354 98.394)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.648,642.823h2.289L517.4,341.536v-3.89Z",
    transform: "translate(-79.772 100.175)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.643,641.044h2.293L518.811,347.537v-3.894Z",
    transform: "translate(-81.188 101.954)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.644,639.265h2.295L520.231,353.543v-3.9Z",
    transform: "translate(-82.606 103.733)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.324,515l-26.3-44.652-1.147,1.938,26.3,44.652Z",
    transform: "translate(-73.919 139.547)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.323,512l-26.306-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-74.627 138.656)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.321,509l-26.3-44.651-1.147,1.946L345.18,510.95Z",
    transform: "translate(-75.336 137.767)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.322,506.008l-26.3-44.662-1.148,1.947,26.307,44.653Z",
    transform: "translate(-76.045 136.875)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.322,503l-26.3-44.653-1.147,1.947,26.3,44.653Z",
    transform: "translate(-76.753 135.986)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.323,500.005l-26.305-44.654-1.143,1.937,26.3,44.662Z",
    transform: "translate(-77.463 135.097)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.32,497l-26.3-44.653-1.148,1.947,26.307,44.653Z",
    transform: "translate(-78.171 134.205)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.322,494l-26.3-44.654-1.147,1.948,26.308,44.653Z",
    transform: "translate(-78.88 133.316)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.321,491.005l-26.3-44.653-1.148,1.938,26.3,44.653Z",
    transform: "translate(-79.588 132.427)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.322,488l-26.306-44.653-1.142,1.947,26.3,44.652Z",
    transform: "translate(-80.298 131.535)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.32,485l-26.3-44.653-1.148,1.947,26.307,44.653Z",
    transform: "translate(-81.006 130.646)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.321,482.008l-26.3-44.661-1.147,1.946,26.307,44.652Z",
    transform: "translate(-81.715 129.755)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.321,479l-26.3-44.653-1.147,1.948L375.18,480.95Z",
    transform: "translate(-82.423 128.866)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.323,476l-26.306-44.652-1.143,1.937,26.307,44.662Z",
    transform: "translate(-83.133 127.977)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,473l-26.3-44.653-1.147,1.948,26.308,44.652Z",
    transform: "translate(-83.841 127.085)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,470l-26.3-44.653-1.148,1.947,26.307,44.653Z",
    transform: "translate(-84.549 126.196)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.321,467l-26.3-44.651-1.146,1.937,26.3,44.653Z",
    transform: "translate(-85.259 125.307)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.322,464l-26.3-44.655-1.148,1.95,26.3,44.654Z",
    transform: "translate(-85.968 124.415)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.323,461l-26.306-44.653-1.143,1.939,26.3,44.661Z",
    transform: "translate(-86.677 123.526)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.32,458.01l-26.3-44.662-1.147,1.946,26.307,44.653Z",
    transform: "translate(-87.385 122.635)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.32,455l-26.3-44.652-1.147,1.946,26.3,44.653Z",
    transform: "translate(-88.093 121.746)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.322,452.006l-26.3-44.654-1.146,1.938,26.3,44.661Z",
    transform: "translate(-88.803 120.856)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.323,449l-26.305-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-89.512 119.965)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.319,446l-26.3-44.653-1.147,1.947,26.307,44.652Z",
    transform: "translate(-90.219 119.076)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32,443.009l-26.3-44.662-1.148,1.947,26.307,44.652Z",
    transform: "translate(-90.929 118.184)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.321,440l-26.3-44.654-1.147,1.948,26.307,44.652Z",
    transform: "translate(-91.637 117.295)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.321,437l-26.306-44.652-1.143,1.937,26.3,44.662Z",
    transform: "translate(-92.346 116.406)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.319,434.01l-26.3-44.662L393.87,391.3l26.307,44.652Z",
    transform: "translate(-93.054 115.514)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.32,431l-26.3-44.654-1.146,1.948,26.307,44.653Z",
    transform: "translate(-93.764 114.625)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.321,428.007l-26.3-44.653-1.148,1.938,26.3,44.652Z",
    transform: "translate(-94.473 113.736)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,425,404.015,380.35l-1.143,1.947,26.3,44.653Z",
    transform: "translate(-95.181 112.845)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.319,422.005l-26.3-44.653-1.148,1.946,26.307,44.654Z",
    transform: "translate(-95.889 111.955)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,419.01l-26.3-44.662-1.147,1.947,26.307,44.652Z",
    transform: "translate(-96.598 111.064)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.319,416l-26.3-44.652-1.148,1.947,26.3,44.653Z",
    transform: "translate(-97.307 110.175)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.32,413.005l-26.306-44.651-1.142,1.937,26.3,44.653Z",
    transform: "translate(-98.016 109.286)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.321,410,419.016,365.35l-1.143,1.947,26.3,44.653Z",
    transform: "translate(-98.725 108.394)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,407l-26.3-44.652-1.148,1.947,26.307,44.652Z",
    transform: "translate(-99.434 107.505)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.321,404.008l-26.3-44.653-1.146,1.937,26.3,44.654Z",
    transform: "translate(-100.143 106.616)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.32,401l-26.306-44.652-1.143,1.946,26.3,44.654Z",
    transform: "translate(-100.851 105.725)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.321,398.006l-26.306-44.653-1.143,1.947,26.3,44.652Z",
    transform: "translate(-101.56 104.835)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.319,395.011l-26.3-44.661-1.148,1.946,26.307,44.653Z",
    transform: "translate(-102.268 103.944)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.319,392l-26.3-44.654L435.87,349.3l26.307,44.653Z",
    transform: "translate(-102.977 103.054)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.32,389.007l-26.3-44.653-1.147,1.938,26.3,44.662Z",
    transform: "translate(-103.686 102.165)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.321,386,443.015,341.35l-1.142,1.948,26.3,44.652Z",
    transform: "translate(-104.395 101.274)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.318,383.005l-26.3-44.652-1.147,1.946,26.309,44.653Z",
    transform: "translate(-105.103 100.385)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.318,380.008l-26.3-44.652-1.148,1.938,26.307,44.651Z",
    transform: "translate(-105.812 99.496)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.319,377l-26.3-44.653-1.147,1.948,26.3,44.652Z",
    transform: "translate(-106.521 98.604)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.321,374.006l-26.305-44.652-1.143,1.946,26.3,44.653Z",
    transform: "translate(-107.23 97.715)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.319,371l-26.3-44.653L456.87,328.3l26.307,44.653Z",
    transform: "translate(-107.939 96.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.319,368.006l-26.3-44.653L459.87,325.3l26.307,44.653Z",
    transform: "translate(-108.647 95.934)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.319,365.008l-26.3-44.653-1.147,1.938,26.3,44.653Z",
    transform: "translate(-109.356 95.045)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.32,362,467.015,317.35l-1.143,1.947,26.3,44.654Z",
    transform: "translate(-110.065 94.154)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.316,359.006l-26.3-44.652-1.148,1.946,26.307,44.654Z",
    transform: "translate(-110.773 93.265)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.318,356.012l-26.3-44.662-1.146,1.947,26.307,44.652Z",
    transform: "translate(-111.482 92.373)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.319,353l-26.3-44.652L474.87,310.3l26.3,44.653Z",
    transform: "translate(-112.191 91.484)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.318,350.008l-26.305-44.654-1.143,1.938,26.3,44.662Z",
    transform: "translate(-112.9 90.595)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.316,347l-26.3-44.652-1.148,1.947,26.307,44.653Z",
    transform: "translate(-113.608 89.703)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.726,573.169h.884l-.442-.751Z",
    transform: "translate(-50.022 169.829)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,571.361l1.59,2.7h2.284l-2.731-4.636Z",
    transform: "translate(-50.512 168.94)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8,568.367l3.878,6.583h2.292l-5.028-8.532Z",
    transform: "translate(-51.221 168.048)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.8,565.367l6.169,10.472h2.292l-7.315-12.419Z",
    transform: "translate(-51.93 167.159)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,562.361l8.463,14.367h2.288l-9.6-16.3Z",
    transform: "translate(-52.638 166.27)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,559.367l10.751,18.253h2.3l-11.9-20.2Z",
    transform: "translate(-53.347 165.378)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,556.371l13.04,22.137h2.293l-14.191-24.087Z",
    transform: "translate(-54.056 164.489)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,553.365,247.137,579.4h2.288l-16.478-27.981Z",
    transform: "translate(-54.764 163.598)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.8,550.369l17.626,29.921h2.293L235.95,548.421Z",
    transform: "translate(-55.474 162.709)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.8,547.361l19.917,33.818h2.291L238.95,545.423Z",
    transform: "translate(-56.183 161.82)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,544.366l22.208,37.7H265.3l-23.359-39.651Z",
    transform: "translate(-56.891 160.929)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,541.369l24.5,41.589h2.289l-25.643-43.536Z",
    transform: "translate(-57.599 160.039)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,538.366l26.306,44.655,1.143-1.94-26.3-44.665Z",
    transform: "translate(-58.308 159.148)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.251,578.074l-26.3-44.653-1.148,1.948,26.3,44.651Z",
    transform: "translate(-59.018 158.259)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.25,575.076l-26.306-44.652-1.143,1.938,26.3,44.662Z",
    transform: "translate(-59.726 157.37)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248,572.072l-26.3-44.653-1.146,1.948,26.307,44.651Z",
    transform: "translate(-60.434 156.478)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249,569.074l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-61.143 155.589)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.251,566.077l-26.3-44.652-1.146,1.937,26.3,44.653Z",
    transform: "translate(-61.853 154.7)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,563.073,265.945,518.42l-1.142,1.947,26.3,44.654Z",
    transform: "translate(-62.561 153.808)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.248,560.077l-26.3-44.653L267.8,517.37l26.307,44.652Z",
    transform: "translate(-63.269 152.919)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.249,557.081l-26.3-44.662-1.147,1.946,26.307,44.654Z",
    transform: "translate(-63.978 152.028)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.249,554.074l-26.3-44.653-1.147,1.947,26.3,44.653Z",
    transform: "translate(-64.687 151.139)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.249,551.078l-26.3-44.654-1.143,1.938,26.3,44.653Z",
    transform: "translate(-65.396 150.249)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.248,548.073l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-66.104 149.358)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.249,545.075l-26.3-44.652L282.8,502.37l26.308,44.653Z",
    transform: "translate(-66.813 148.469)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.25,542.078l-26.3-44.653-1.148,1.938,26.307,44.653Z",
    transform: "translate(-67.523 147.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,539.074l-26.3-44.653-1.147,1.948,26.3,44.652Z",
    transform: "translate(-68.231 146.688)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.251,536.076l-26.305-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-68.94 145.799)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.248,533.081l-26.3-44.662-1.146,1.947,26.307,44.653Z",
    transform: "translate(-69.648 144.907)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.248,530.075l-26.3-44.653L297.8,487.37l26.307,44.651Z",
    transform: "translate(-70.357 144.018)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.25,527.078l-26.3-44.652-1.147,1.937,26.3,44.653Z",
    transform: "translate(-71.066 143.129)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.251,524.074l-26.306-44.653-1.143,1.948,26.3,44.652Z",
    transform: "translate(-71.775 142.238)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.248,521.076l-26.3-44.653-1.146,1.947,26.307,44.654Z",
    transform: "translate(-72.484 141.348)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.248,518.081l-26.3-44.662-1.147,1.947,26.307,44.652Z",
    transform: "translate(-73.192 140.457)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.017,0,439.091,434.763l1.147-1.94L185.31,0Z",
    transform: "translate(-43.239)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.02,0,442.8,430.873l1.148-1.938L191.312,0Z",
    transform: "translate(-44.657)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.019,0,446.511,426.989l1.146-1.959L197.31,0Z",
    transform: "translate(-46.075)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.017,0l249.2,423.092,1.143-1.938L203.307,0Z",
    transform: "translate(-47.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.017,0,453.927,419.206l1.148-1.941L209.309,0Z",
    transform: "translate(-48.909)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.015,0,457.634,415.319l1.148-1.958L215.313,0Z",
    transform: "translate(-50.326)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.018,0l242.33,411.434,1.146-1.949L221.307,0Z",
    transform: "translate(-51.744)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.015,0,465.051,407.538l1.153-1.947L227.31,0Z",
    transform: "translate(-53.161)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.016,0,468.759,403.641l1.148-1.938L233.308,0Z",
    transform: "translate(-54.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.02,0,472.474,399.753l1.148-1.939L239.307,0Z",
    transform: "translate(-55.998)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.019,0,476.18,395.867l1.147-1.947L245.307,0Z",
    transform: "translate(-57.415)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.015,0,479.884,391.971l1.154-1.938L251.31,0Z",
    transform: "translate(-58.831)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.613,97.126l-26.306,44.661-1.142-1.947,26.3-44.652Z",
    transform: "translate(-57.449 28.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,100.127l-26.3,44.662-1.147-1.947L272.47,98.19Z",
    transform: "translate(-58.157 29.132)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.612,103.128l-26.3,44.652-1.148-1.937L275.47,101.19Z",
    transform: "translate(-58.867 30.022)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.613,106.131l-26.3,44.654-1.147-1.939,26.3-44.661Z",
    transform: "translate(-59.576 30.91)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.613,109.126l-26.306,44.661-1.143-1.946,26.3-44.653Z",
    transform: "translate(-60.284 31.801)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,112.126l-26.3,44.662-1.147-1.947,26.307-44.653Z",
    transform: "translate(-60.992 32.692)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.611,115.127l-26.3,44.653-1.15-1.937,26.308-44.654Z",
    transform: "translate(-61.701 33.582)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.611,118.13l-26.3,44.655-1.146-1.94,26.3-44.662Z",
    transform: "translate(-62.41 34.47)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.612,121.131l-26.306,44.654-1.143-1.947,26.3-44.653Z",
    transform: "translate(-63.119 35.36)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.614,124.127l-26.305,44.661-1.143-1.946,26.3-44.653Z",
    transform: "translate(-63.828 36.252)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.611,127.126l-26.3,44.654-1.146-1.938,26.307-44.652Z",
    transform: "translate(-64.537 37.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.611,130.128l-26.3,44.653-1.148-1.939L302.47,128.19Z",
    transform: "translate(-65.245 38.032)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.612,133.131l-26.305,44.652-1.143-1.946,26.307-44.653Z",
    transform: "translate(-65.954 38.92)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.614,136.125l-26.306,44.662-1.143-1.946,26.3-44.653Z",
    transform: "translate(-66.663 39.812)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.611,139.127l-26.3,44.654-1.147-1.94L311.47,137.19Z",
    transform: "translate(-67.372 40.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.611,142.13l-26.3,44.653-1.147-1.938,26.307-44.662Z",
    transform: "translate(-68.08 41.59)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.612,145.13l-26.3,44.654-1.148-1.95,26.3-44.652Z",
    transform: "translate(-68.789 42.481)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.613,148.126l-26.305,44.662-1.143-1.947,26.3-44.654Z",
    transform: "translate(-69.498 43.372)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.609,151.127l-26.3,44.654-1.148-1.94,26.307-44.653Z",
    transform: "translate(-70.206 44.262)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.61,154.126l-26.3,44.654-1.147-1.938,26.307-44.653Z",
    transform: "translate(-70.915 45.153)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.611,157.131l-26.3,44.653-1.148-1.938,26.3-44.662Z",
    transform: "translate(-71.624 46.041)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.613,160.125l-26.306,44.662-1.142-1.946,26.3-44.653Z",
    transform: "translate(-72.333 46.932)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.614,163.125l-26.305,44.653-1.143-1.938,26.3-44.653Z",
    transform: "translate(-73.042 47.822)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,166.128l-26.3,44.655-1.147-1.94,26.307-44.662Z",
    transform: "translate(-73.75 48.71)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.611,169.129l-26.3,44.653-1.146-1.938,26.3-44.662Z",
    transform: "translate(-74.459 49.601)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.613,172.124l-26.307,44.661-1.143-1.946,26.3-44.652Z",
    transform: "translate(-75.168 50.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.613,175.125l-26.306,44.662-1.143-1.947,26.3-44.652Z",
    transform: "translate(-75.877 51.383)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,178.129l-26.3,44.652-1.148-1.938,26.308-44.662Z",
    transform: "translate(-76.585 52.271)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.611,181.128l-26.3,44.653-1.146-1.938,26.307-44.661Z",
    transform: "translate(-77.294 53.161)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.61,184.125l-26.3,44.661-1.148-1.947,26.3-44.654Z",
    transform: "translate(-78.003 54.052)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.612,187.125l-26.305,44.661-1.143-1.947,26.3-44.653Z",
    transform: "translate(-78.712 54.942)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.609,190.125l-26.3,44.654-1.147-1.937,26.307-44.654Z",
    transform: "translate(-79.42 55.833)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.611,193.129l-26.3,44.653-1.148-1.938,26.3-44.662Z",
    transform: "translate(-80.129 56.721)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.612,196.129l-26.3,44.653-1.147-1.947,26.3-44.653Z",
    transform: "translate(-80.838 57.611)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.612,199.124l-26.306,44.661-1.142-1.947,26.3-44.651Z",
    transform: "translate(-81.547 58.503)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.609,202.125l-26.3,44.653-1.147-1.938,26.307-44.653Z",
    transform: "translate(-82.255 59.393)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.609,205.128l-26.3,44.652-1.146-1.937,26.307-44.662Z",
    transform: "translate(-82.964 60.281)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61,208.129l-26.3,44.653-1.146-1.948,26.3-44.651Z",
    transform: "translate(-83.673 61.172)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.611,211.124l-26.306,44.662-1.143-1.947,26.3-44.653Z",
    transform: "translate(-84.382 62.063)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.609,214.125l-26.3,44.652-1.148-1.937,26.307-44.653Z",
    transform: "translate(-85.09 62.953)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,217.128l-26.3,44.653-1.146-1.938,26.307-44.662Z",
    transform: "translate(-85.799 63.841)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,220.128l-26.3,44.653-1.148-1.947,26.3-44.652Z",
    transform: "translate(-86.508 64.731)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.611,223.124l-26.305,44.662-1.143-1.947,26.3-44.653Z",
    transform: "translate(-87.217 65.623)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.609,226.125l-26.3,44.653-1.147-1.938,26.307-44.653Z",
    transform: "translate(-87.925 66.513)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.608,229.125l-26.3,44.654-1.147-1.938,26.307-44.652Z",
    transform: "translate(-88.634 67.404)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,232.127l-26.3,44.653-1.147-1.938,26.3-44.662Z",
    transform: "translate(-89.343 68.291)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.611,235.122,382.3,279.785l-1.142-1.947,26.3-44.652Z",
    transform: "translate(-90.052 69.183)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.607,238.124l-26.3,44.653-1.147-1.939,26.308-44.653Z",
    transform: "translate(-90.76 70.073)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.608,241.125l-26.3,44.651-1.146-1.937,26.306-44.652Z",
    transform: "translate(-91.469 70.964)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.61,244.127l-26.3,44.653-1.147-1.937,26.3-44.662Z",
    transform: "translate(-92.178 71.852)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.61,247.129,394.3,291.781l-1.143-1.947,26.3-44.653Z",
    transform: "translate(-92.887 72.742)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.608,250.124l-26.3,44.662-1.146-1.948,26.307-44.653Z",
    transform: "translate(-93.595 73.633)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.607,253.124l-26.3,44.652-1.147-1.938,26.307-44.652Z",
    transform: "translate(-94.304 74.524)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.609,256.127l-26.3,44.662-1.146-1.946,26.3-44.662Z",
    transform: "translate(-95.013 75.412)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.61,259.128,406.3,303.781l-1.143-1.946,26.3-44.654Z",
    transform: "translate(-95.722 76.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.609,262.123,409.3,306.775l-1.143-1.938,26.3-44.652Z",
    transform: "translate(-96.431 77.194)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.608,265.124l-26.3,44.662-1.147-1.947,26.307-44.653Z",
    transform: "translate(-97.139 78.084)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.518,0l-.426.722L115.24,2.66,116.808,0Z",
    transform: "translate(-26.955)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.805,0l-2.711,4.6,1.141,1.949L122.1,0Z",
    transform: "translate(-27.664)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,0l-5.006,8.5,1.143,1.948L127.391,0Z",
    transform: "translate(-28.373)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.393,0l-7.3,12.391,1.146,1.937L132.679,0Z",
    transform: "translate(-29.082)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.684,0l-9.592,16.282,1.147,1.937L137.971,0Z",
    transform: "translate(-29.79)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.969,0,129.093,20.162l1.148,1.946L143.264,0Z",
    transform: "translate(-30.499)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.266,0,132.095,24.058l1.141,1.95L148.555,0Z",
    transform: "translate(-31.208)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.558,0,135.09,27.951l1.148,1.937L153.843,0Z",
    transform: "translate(-31.916)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.848,0,138.094,31.84l1.147,1.94L159.137,0Z",
    transform: "translate(-32.626)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.134,0l-21.04,35.722,1.147,1.947L164.428,0Z",
    transform: "translate(-33.334)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,0,144.094,39.619l1.142,1.946L169.719,0Z",
    transform: "translate(-34.043)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.724,0,147.09,43.51l1.148,1.938L174.539.793,174.072,0Z",
    transform: "translate(-34.751)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54,4.06l-26.3,44.652-1.147-1.938L176.4,2.112Z",
    transform: "translate(-35.46 0.627)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.542,7.059l-26.3,44.653-1.146-1.947,26.3-44.653Z",
    transform: "translate(-36.169 1.517)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.543,10.055,157.237,54.717l-1.143-1.947L182.4,8.117Z",
    transform: "translate(-36.878 2.408)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.539,13.055l-26.3,44.652L159.09,55.77,185.4,11.118Z",
    transform: "translate(-37.586 3.299)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.54,16.056l-26.3,44.655-1.147-1.94L188.4,14.118Z",
    transform: "translate(-38.295 4.189)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.541,19.058,166.235,63.71l-1.143-1.947L191.4,17.119Z",
    transform: "translate(-39.004 5.079)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.541,22.06,169.235,66.713l-1.143-1.947,26.3-44.652Z",
    transform: "translate(-39.713 5.967)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.538,25.056l-26.3,44.661-1.147-1.946L197.4,23.118Z",
    transform: "translate(-40.421 6.859)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,28.055l-26.3,44.654-1.146-1.938L200.4,26.118Z",
    transform: "translate(-41.13 7.749)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.541,31.057l-26.3,44.653-1.147-1.938,26.3-44.653Z",
    transform: "translate(-41.839 8.639)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.54,34.06,181.235,78.713l-1.143-1.948,26.3-44.653Z",
    transform: "translate(-42.548 9.527)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.538,37.055l-26.3,44.661-1.147-1.946L209.4,35.117Z",
    transform: "translate(-43.256 10.419)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.54,40.055l-26.3,44.653-1.146-1.938L212.4,38.119Z",
    transform: "translate(-43.965 11.309)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.541,43.058l-26.3,44.654-1.146-1.939L215.4,41.111Z",
    transform: "translate(-44.674 12.197)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.542,46.059l-26.3,44.652-1.147-1.946,26.3-44.653Z",
    transform: "translate(-45.383 13.087)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.541,49.053,196.236,93.716l-1.143-1.946,26.3-44.653Z",
    transform: "translate(-46.092 13.979)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.539,52.055l-26.3,44.652L198.09,94.77,224.4,50.117Z",
    transform: "translate(-46.8 14.869)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54,55.058l-26.3,44.653-1.147-1.938L227.4,53.111Z",
    transform: "translate(-47.509 15.757)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,58.059l-26.3,44.655-1.147-1.95,26.3-44.653Z",
    transform: "translate(-48.218 16.648)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.541,61.055l-26.306,44.661-1.142-1.947,26.3-44.653Z",
    transform: "translate(-48.927 17.539)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.539,64.055l-26.3,44.652-1.147-1.937L236.4,62.116Z",
    transform: "translate(-49.635 18.429)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.538,67.057l-26.3,44.653-1.148-1.938L239.4,65.11Z",
    transform: "translate(-50.344 19.317)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,70.058l-26.3,44.654-1.147-1.948,26.3-44.652Z",
    transform: "translate(-51.053 20.208)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.541,73.054l-26.306,44.661-1.143-1.947,26.3-44.652Z",
    transform: "translate(-51.762 21.099)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.539,76.054l-26.3,44.654-1.146-1.938L248.4,74.117Z",
    transform: "translate(-52.47 21.989)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,79.057l-26.3,44.652-1.146-1.938L251.4,77.109Z",
    transform: "translate(-53.179 22.877)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.539,82.057l-26.3,44.653-1.147-1.947,26.3-44.652Z",
    transform: "translate(-53.888 23.768)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.541,85.053l-26.306,44.661-1.143-1.946,26.3-44.653Z",
    transform: "translate(-54.597 24.659)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.537,88.054l-26.3,44.662-1.148-1.948,26.307-44.653Z",
    transform: "translate(-55.305 25.549)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.538,91.055l-26.3,44.654-1.147-1.939L263.4,89.117Z",
    transform: "translate(-56.014 26.44)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.539,94.057l-26.3,44.653-1.146-1.937,26.3-44.662Z",
    transform: "translate(-56.723 27.328)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.786,664.027h2.289l233.184-395.9-1.141-1.95Z",
    transform: "translate(-33.498 78.971)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.782,663.136h2.295L380.966,271.13l-1.147-1.947Z",
    transform: "translate(-34.915 79.863)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.78,662.246h2.291l228.6-388.128-1.147-1.938Z",
    transform: "translate(-36.332 80.752)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.782,661.357h2.29L388.383,277.125l-1.143-1.946Z",
    transform: "translate(-37.75 81.642)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.783,660.466h2.289L392.091,280.13l-1.143-1.949Z",
    transform: "translate(-39.167 82.533)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.776,659.576h2.3L395.8,283.129l-1.148-1.95Z",
    transform: "translate(-40.583 83.422)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.783,658.686h2.291L399.512,286.125l-1.147-1.946Z",
    transform: "translate(-42.002 84.312)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.782,657.8h2.285L403.216,289.119l-1.141-1.938Z",
    transform: "translate(-43.42 85.203)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.78,656.906h2.292l214.854-364.78-1.148-1.946Z",
    transform: "translate(-44.837 86.092)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.781,656.015h2.289L410.637,295.122l-1.148-1.94Z",
    transform: "translate(-46.255 86.983)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.778,655.126h2.292l210.273-357-1.147-1.95Z",
    transform: "translate(-47.671 87.872)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.783,654.236h2.29l207.98-353.11-1.143-1.947Z",
    transform: "translate(-49.09 88.762)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.458,515l-26.306-44.652-1.142,1.938,26.3,44.652Z",
    transform: "translate(-40.402 139.547)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.455,512l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-41.11 138.656)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.455,509l-26.3-44.651-1.148,1.946,26.307,44.653Z",
    transform: "translate(-41.819 137.767)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.457,506.008l-26.3-44.662-1.146,1.947,26.3,44.653Z",
    transform: "translate(-42.528 136.875)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.458,503l-26.306-44.653L183.01,460.3l26.3,44.653Z",
    transform: "translate(-43.237 135.986)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.456,500.005l-26.3-44.654-1.148,1.937,26.307,44.662Z",
    transform: "translate(-43.946 135.097)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.455,497l-26.3-44.653-1.147,1.947,26.307,44.653Z",
    transform: "translate(-44.654 134.205)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.457,494l-26.3-44.654-1.148,1.948,26.3,44.653Z",
    transform: "translate(-45.363 133.316)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.457,491.005l-26.305-44.653-1.143,1.938,26.3,44.653Z",
    transform: "translate(-46.072 132.427)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.457,488l-26.305-44.653-1.143,1.947,26.3,44.652Z",
    transform: "translate(-46.781 131.535)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.455,485l-26.3-44.653-1.146,1.947,26.307,44.653Z",
    transform: "translate(-47.489 130.646)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.456,482.008l-26.3-44.661-1.147,1.946,26.307,44.652Z",
    transform: "translate(-48.198 129.755)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.457,479,208.151,434.35l-1.142,1.948,26.3,44.652Z",
    transform: "translate(-48.907 128.866)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.453,476l-26.3-44.652L210,433.29l26.308,44.662Z",
    transform: "translate(-49.615 127.977)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.455,473l-26.3-44.653-1.148,1.948,26.307,44.652Z",
    transform: "translate(-50.324 127.085)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.456,470l-26.3-44.653-1.147,1.947,26.307,44.653Z",
    transform: "translate(-51.033 126.196)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.457,467l-26.306-44.651-1.143,1.937,26.3,44.653Z",
    transform: "translate(-51.742 125.307)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.457,464l-26.306-44.655-1.143,1.95,26.3,44.654Z",
    transform: "translate(-52.451 124.415)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.455,461l-26.3-44.653-1.146,1.939,26.307,44.661Z",
    transform: "translate(-53.159 123.526)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.456,458.01l-26.3-44.662-1.147,1.946,26.307,44.653Z",
    transform: "translate(-53.868 122.635)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.456,455,232.15,410.351l-1.143,1.946,26.3,44.653Z",
    transform: "translate(-54.577 121.746)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.456,452.006l-26.305-44.654-1.143,1.938,26.3,44.661Z",
    transform: "translate(-55.286 120.856)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.454,449l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-55.994 119.965)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.455,446l-26.3-44.653-1.148,1.947,26.307,44.652Z",
    transform: "translate(-56.703 119.076)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.455,443.009l-26.3-44.662-1.147,1.947,26.3,44.652Z",
    transform: "translate(-57.412 118.184)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.456,440,247.15,395.35l-1.142,1.948,26.3,44.652Z",
    transform: "translate(-58.121 117.295)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.454,437l-26.3-44.652-1.146,1.937,26.307,44.662Z",
    transform: "translate(-58.829 116.406)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.455,434.01l-26.3-44.662-1.147,1.948,26.307,44.652Z",
    transform: "translate(-59.538 115.514)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.455,431l-26.3-44.654-1.148,1.948,26.3,44.653Z",
    transform: "translate(-60.247 114.625)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.456,428.007l-26.305-44.653-1.143,1.938,26.3,44.652Z",
    transform: "translate(-60.956 113.736)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.456,425,262.15,380.35l-1.143,1.947,26.3,44.653Z",
    transform: "translate(-61.665 112.845)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.453,422.005l-26.3-44.653L264,379.3l26.307,44.654Z",
    transform: "translate(-62.373 111.955)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.454,419.01l-26.3-44.662-1.147,1.947,26.3,44.652Z",
    transform: "translate(-63.082 111.064)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.456,416,271.15,371.351l-1.143,1.947,26.3,44.653Z",
    transform: "translate(-63.791 110.175)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.453,413.005l-26.3-44.651L273,370.291l26.308,44.653Z",
    transform: "translate(-64.499 109.286)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.453,410l-26.3-44.653L276,367.3l26.307,44.653Z",
    transform: "translate(-65.208 108.394)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.454,407l-26.3-44.652-1.147,1.947,26.3,44.652Z",
    transform: "translate(-65.917 107.505)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.456,404.008,283.15,359.355l-1.143,1.937,26.3,44.654Z",
    transform: "translate(-66.626 106.616)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.457,401l-26.306-44.652-1.144,1.946,26.3,44.654Z",
    transform: "translate(-67.335 105.725)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.453,398.006l-26.3-44.653L288,355.3l26.307,44.652Z",
    transform: "translate(-68.043 104.835)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.454,395.011l-26.3-44.661-1.147,1.946,26.307,44.653Z",
    transform: "translate(-68.752 103.944)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.456,392l-26.3-44.654-1.146,1.948,26.3,44.653Z",
    transform: "translate(-69.461 103.054)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.455,389.007l-26.305-44.653-1.143,1.938,26.3,44.662Z",
    transform: "translate(-70.17 102.165)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.453,386l-26.3-44.653L300,343.3l26.307,44.652Z",
    transform: "translate(-70.878 101.274)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.453,383.005l-26.3-44.652-1.146,1.946,26.307,44.653Z",
    transform: "translate(-71.587 100.385)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.455,380.008l-26.3-44.652-1.147,1.938,26.3,44.651Z",
    transform: "translate(-72.296 99.496)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.455,377l-26.306-44.653-1.143,1.948,26.3,44.652Z",
    transform: "translate(-73.005 98.604)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.452,374.006l-26.3-44.652L312,331.3l26.308,44.653Z",
    transform: "translate(-73.713 97.715)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.453,371l-26.3-44.653-1.146,1.948,26.307,44.653Z",
    transform: "translate(-74.422 96.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.453,368.006l-26.3-44.653L318,325.3l26.3,44.653Z",
    transform: "translate(-75.131 95.934)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.454,365.008l-26.305-44.653-1.143,1.938,26.3,44.653Z",
    transform: "translate(-75.84 95.045)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.452,362l-26.3-44.653L324,319.3l26.307,44.654Z",
    transform: "translate(-76.548 94.154)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.453,359.006l-26.3-44.652L327,316.3l26.307,44.654Z",
    transform: "translate(-77.257 93.265)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.454,356.012l-26.3-44.662-1.147,1.947,26.3,44.652Z",
    transform: "translate(-77.966 92.373)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.454,353l-26.306-44.652-1.142,1.946,26.3,44.653Z",
    transform: "translate(-78.675 91.484)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.451,350.008l-26.3-44.654L336,307.292l26.307,44.662Z",
    transform: "translate(-79.383 90.595)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.453,347l-26.3-44.652L339,304.3l26.307,44.653Z",
    transform: "translate(-80.092 89.703)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.863,573.169h.884l-.442-.751Z",
    transform: "translate(-16.506 169.829)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.935,571.361l1.589,2.7h2.288l-2.731-4.636Z",
    transform: "translate(-16.995 168.94)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.936,568.367l3.879,6.583h2.293l-5.025-8.532Z",
    transform: "translate(-17.704 168.048)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.937,565.367l6.17,10.472H86.4l-7.315-12.419Z",
    transform: "translate(-18.413 167.159)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.939,562.361,89.4,576.728h2.289l-9.6-16.3Z",
    transform: "translate(-19.122 166.27)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.938,559.367l10.751,18.253h2.292l-11.9-20.2Z",
    transform: "translate(-19.831 165.378)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.936,556.371l13.042,22.137h2.293L88.083,554.421Z",
    transform: "translate(-20.539 164.489)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.937,553.365,105.274,579.4h2.288L91.084,551.418Z",
    transform: "translate(-21.248 163.598)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.937,550.369l17.623,29.921h2.294L94.078,548.421Z",
    transform: "translate(-21.957 162.709)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,547.361l19.917,33.818h2.289L97.081,545.423Z",
    transform: "translate(-22.666 161.82)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.935,544.366l22.212,37.7h2.29l-23.355-39.651Z",
    transform: "translate(-23.374 160.929)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.934,541.369l24.5,41.589h2.289l-25.644-43.536Z",
    transform: "translate(-24.083 160.039)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.938,538.366l26.3,44.655,1.148-1.94-26.3-44.665Z",
    transform: "translate(-24.792 159.148)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.386,578.074,109.08,533.421l-1.143,1.948,26.3,44.651Z",
    transform: "translate(-25.501 158.259)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.383,575.076l-26.3-44.652-1.147,1.938,26.307,44.662Z",
    transform: "translate(-26.209 157.37)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.383,572.072l-26.3-44.653-1.147,1.948,26.307,44.651Z",
    transform: "translate(-26.918 156.478)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.385,569.074l-26.3-44.652-1.147,1.947,26.3,44.652Z",
    transform: "translate(-27.627 155.589)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.386,566.077,121.08,521.425l-1.142,1.937,26.3,44.653Z",
    transform: "translate(-28.336 154.7)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.387,563.073,124.082,518.42l-1.143,1.947,26.3,44.654Z",
    transform: "translate(-29.045 153.808)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.385,560.077l-26.3-44.653-1.147,1.947,26.307,44.652Z",
    transform: "translate(-29.753 152.919)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.384,557.081l-26.3-44.662-1.148,1.946,26.306,44.654Z",
    transform: "translate(-30.462 152.028)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.385,554.074l-26.306-44.653-1.143,1.947,26.3,44.653Z",
    transform: "translate(-31.171 151.139)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.383,551.078l-26.3-44.654-1.146,1.938,26.307,44.653Z",
    transform: "translate(-31.879 150.249)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.383,548.073l-26.3-44.652-1.147,1.947,26.307,44.652Z",
    transform: "translate(-32.588 149.358)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.384,545.075l-26.3-44.652-1.147,1.946,26.307,44.653Z",
    transform: "translate(-33.297 148.469)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.385,542.078l-26.3-44.653-1.147,1.938,26.3,44.653Z",
    transform: "translate(-34.006 147.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.384,539.074l-26.305-44.653-1.143,1.948,26.3,44.652Z",
    transform: "translate(-34.715 146.688)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.383,536.076l-26.3-44.652-1.148,1.947,26.307,44.652Z",
    transform: "translate(-35.423 145.799)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.383,533.081l-26.3-44.662-1.147,1.947,26.308,44.653Z",
    transform: "translate(-36.132 144.907)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.385,530.075l-26.3-44.653-1.146,1.948,26.3,44.651Z",
    transform: "translate(-36.841 144.018)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.386,527.078l-26.306-44.652-1.143,1.937,26.3,44.653Z",
    transform: "translate(-37.55 143.129)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.382,524.074l-26.3-44.653-1.146,1.948,26.307,44.652Z",
    transform: "translate(-38.258 142.238)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.384,521.076l-26.3-44.653-1.148,1.947,26.307,44.654Z",
    transform: "translate(-38.967 141.348)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.384,518.081l-26.3-44.662-1.147,1.947,26.3,44.652Z",
    transform: "translate(-39.676 140.457)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.15,0,297.226,434.768l1.148-1.95L43.445,0Z",
    transform: "translate(-9.722)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.155,0l253.78,430.869,1.148-1.938L49.447,0Z",
    transform: "translate(-11.141)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.154,0,304.647,426.991l1.148-1.956L55.449,0Z",
    transform: "translate(-12.558)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.153,0,308.359,423.1l1.143-1.949L61.445,0Z",
    transform: "translate(-13.975)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.155,0,312.066,419.2l1.143-1.938L67.442,0Z",
    transform: "translate(-15.393)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.154,0,315.773,415.319l1.148-1.958L73.449,0Z",
    transform: "translate(-16.811)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.153,0l242.33,411.434,1.143-1.949L79.443,0Z",
    transform: "translate(-18.228)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.152,0,323.194,407.538l1.14-1.947L85.445,0Z",
    transform: "translate(-19.645)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.151,0,326.894,403.641l1.148-1.938L91.443,0Z",
    transform: "translate(-21.063)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.153,0,330.607,399.753l1.148-1.939L97.443,0Z",
    transform: "translate(-22.48)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.154,0,334.315,395.867l1.147-1.947L103.442,0Z",
    transform: "translate(-23.898)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.153,0,338.025,391.971l1.143-1.938L109.44,0Z",
    transform: "translate(-25.316)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746,97.126l-26.3,44.661L101.3,139.84l26.308-44.652Z",
    transform: "translate(-23.932 28.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.746,100.127l-26.3,44.662-1.148-1.947L130.6,98.19Z",
    transform: "translate(-24.641 29.132)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.747,103.128l-26.3,44.652-1.147-1.937,26.3-44.653Z",
    transform: "translate(-25.35 30.022)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.748,106.131l-26.305,44.654-1.143-1.939,26.3-44.661Z",
    transform: "translate(-26.059 30.91)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.748,109.126l-26.306,44.661-1.143-1.946,26.3-44.653Z",
    transform: "translate(-26.768 31.801)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.745,112.126l-26.3,44.662-1.146-1.947L142.6,110.189Z",
    transform: "translate(-27.476 32.692)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.747,115.127l-26.3,44.653-1.147-1.937,26.307-44.654Z",
    transform: "translate(-28.185 33.582)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.748,118.13l-26.306,44.655-1.142-1.94,26.3-44.662Z",
    transform: "translate(-28.894 34.47)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.748,121.131l-26.305,44.654-1.144-1.947,26.3-44.653Z",
    transform: "translate(-29.603 35.36)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.745,124.127l-26.3,44.661-1.147-1.946L154.6,122.189Z",
    transform: "translate(-30.311 36.252)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.746,127.126l-26.3,44.654-1.148-1.938,26.307-44.652Z",
    transform: "translate(-31.02 37.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.748,130.128l-26.3,44.653-1.147-1.939,26.3-44.652Z",
    transform: "translate(-31.729 38.032)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.743,133.131l-26.3,44.652-1.146-1.946L163.6,131.184Z",
    transform: "translate(-32.437 38.92)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.745,136.125l-26.3,44.662-1.147-1.946L166.6,134.188Z",
    transform: "translate(-33.146 39.812)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.746,139.127l-26.3,44.654-1.146-1.94L169.6,137.19Z",
    transform: "translate(-33.855 40.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.748,142.13l-26.3,44.653-1.148-1.938,26.3-44.662Z",
    transform: "translate(-34.564 41.59)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.747,145.13l-26.305,44.654-1.143-1.95,26.3-44.652Z",
    transform: "translate(-35.273 42.481)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.745,148.126l-26.3,44.662-1.147-1.947L178.6,146.187Z",
    transform: "translate(-35.981 43.372)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.746,151.127l-26.3,44.654-1.147-1.94L181.6,149.188Z",
    transform: "translate(-36.69 44.262)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.746,154.126l-26.3,44.654-1.15-1.938,26.3-44.653Z",
    transform: "translate(-37.399 45.153)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.746,157.131l-26.306,44.653-1.142-1.938,26.3-44.662Z",
    transform: "translate(-38.108 46.041)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.744,160.125l-26.3,44.662-1.147-1.946L190.6,158.188Z",
    transform: "translate(-38.816 46.932)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.746,163.125l-26.3,44.653L167.3,205.84,193.6,161.188Z",
    transform: "translate(-39.525 47.822)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.745,166.128l-26.3,44.655-1.146-1.94,26.3-44.662Z",
    transform: "translate(-40.234 48.71)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.746,169.129,174.44,213.782l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-40.943 49.601)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.744,172.124l-26.3,44.661-1.147-1.946L202.6,170.187Z",
    transform: "translate(-41.651 50.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.745,175.125l-26.3,44.662L179.3,217.84,205.6,173.188Z",
    transform: "translate(-42.36 51.383)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.746,178.129l-26.3,44.652-1.146-1.938,26.3-44.662Z",
    transform: "translate(-43.069 52.271)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.746,181.128l-26.3,44.653-1.147-1.938,26.3-44.661Z",
    transform: "translate(-43.778 53.161)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.747,184.125l-26.305,44.661-1.143-1.947,26.3-44.654Z",
    transform: "translate(-44.487 54.052)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.745,187.125l-26.3,44.661L191.3,229.84,217.6,185.187Z",
    transform: "translate(-45.195 54.942)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.744,190.125l-26.3,44.654-1.147-1.937L220.6,188.188Z",
    transform: "translate(-45.904 55.833)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.745,193.129,198.44,237.782l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-46.613 56.721)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.747,196.129l-26.305,44.653-1.143-1.947,26.3-44.653Z",
    transform: "translate(-47.322 57.611)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.745,199.124l-26.3,44.661-1.147-1.947L229.6,197.187Z",
    transform: "translate(-48.03 58.503)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.744,202.125l-26.3,44.653L206.3,244.84,232.6,200.187Z",
    transform: "translate(-48.739 59.393)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.745,205.128l-26.3,44.652-1.147-1.937,26.3-44.662Z",
    transform: "translate(-49.448 60.281)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.747,208.129l-26.305,44.653-1.143-1.948,26.3-44.651Z",
    transform: "translate(-50.157 61.172)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.744,211.124l-26.3,44.662-1.146-1.947L241.6,209.187Z",
    transform: "translate(-50.865 62.063)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.744,214.125l-26.3,44.652L218.3,256.84,244.6,212.187Z",
    transform: "translate(-51.574 62.953)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.745,217.128,222.439,261.78l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-52.283 63.841)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.746,220.128,225.441,264.78l-1.142-1.947,26.3-44.652Z",
    transform: "translate(-52.992 64.731)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.742,223.124l-26.3,44.662-1.147-1.947L253.6,221.186Z",
    transform: "translate(-53.7 65.623)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.743,226.125l-26.3,44.653L230.3,268.84,256.6,224.187Z",
    transform: "translate(-54.409 66.513)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.745,229.125l-26.3,44.654L233.3,271.84l26.3-44.652Z",
    transform: "translate(-55.118 67.404)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.746,232.127,237.44,276.78l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-55.827 68.291)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.742,235.122l-26.3,44.662-1.148-1.947L265.6,233.185Z",
    transform: "translate(-56.535 69.183)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.743,238.124l-26.3,44.653-1.147-1.939L268.6,236.186Z",
    transform: "translate(-57.244 70.073)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.743,241.125l-26.3,44.651-1.15-1.937,26.3-44.652Z",
    transform: "translate(-57.952 70.964)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.744,244.127,249.438,288.78l-1.142-1.937,26.3-44.662Z",
    transform: "translate(-58.662 71.852)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.742,247.129l-26.3,44.652-1.146-1.947L277.6,245.181Z",
    transform: "translate(-59.37 72.742)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.743,250.124l-26.3,44.662-1.147-1.948L280.6,248.186Z",
    transform: "translate(-60.079 73.633)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.742,253.124l-26.3,44.652-1.147-1.938L283.6,251.187Z",
    transform: "translate(-60.787 74.524)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.744,256.127l-26.305,44.662-1.143-1.946,26.3-44.662Z",
    transform: "translate(-61.497 75.412)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.741,259.128l-26.3,44.653-1.147-1.946L289.6,257.181Z",
    transform: "translate(-62.205 76.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.742,262.123l-26.3,44.653-1.148-1.938L292.6,260.186Z",
    transform: "translate(-62.914 77.194)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.743,265.124l-26.3,44.662-1.147-1.947,26.3-44.653Z",
    transform: "translate(-63.622 78.084)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.124,0,0,3.6v3.89L4.415,0Z",
    transform: "translate(0)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71,0,0,11.39v3.89L9,0Z",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.293,0,0,19.169v3.884L13.579,0Z",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87,0,0,26.947v3.887L18.162,0Z",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.451,0,0,34.722v2.005l.552.942L22.744,0Z",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.567,0,2.227,39.619l1.147,1.946L27.853,0Z",
    transform: "translate(-0.526)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.859,0,5.227,43.51l1.147,1.938L32.675.793,32.207,0Z",
    transform: "translate(-1.235)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.677,4.06,9.376,48.712,8.229,46.774,34.536,2.112Z",
    transform: "translate(-1.944 0.627)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.677,7.059,12.371,51.712l-1.143-1.947L37.53,5.112Z",
    transform: "translate(-2.653 1.517)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.674,10.055l-26.3,44.661-1.148-1.947L40.533,8.117Z",
    transform: "translate(-3.361 2.408)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.675,13.055l-26.3,44.652L17.227,55.77,43.534,11.118Z",
    transform: "translate(-4.07 3.299)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.675,16.056l-26.3,44.655-1.148-1.94L46.534,14.118Z",
    transform: "translate(-4.779 4.189)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.676,19.058,24.371,63.71l-1.143-1.947,26.3-44.643Z",
    transform: "translate(-5.488 5.079)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.674,22.06l-26.3,44.653-1.147-1.947L52.532,20.114Z",
    transform: "translate(-6.196 5.967)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.675,25.056l-26.3,44.661-1.147-1.946L55.534,23.118Z",
    transform: "translate(-6.905 6.859)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.674,28.055l-26.3,44.654-1.147-1.938L58.533,26.118Z",
    transform: "translate(-7.614 7.749)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.676,31.057,36.37,75.709l-1.143-1.938,26.3-44.653Z",
    transform: "translate(-8.323 8.639)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.677,34.06,39.372,78.713l-1.143-1.948,26.3-44.653Z",
    transform: "translate(-9.032 9.527)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.673,37.055l-26.3,44.661-1.15-1.946L67.532,35.117Z",
    transform: "translate(-9.74 10.419)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.674,40.055l-26.3,44.653-1.147-1.938,26.3-44.652Z",
    transform: "translate(-10.449 11.309)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.676,43.058l-26.3,44.654-1.146-1.939,26.3-44.662Z",
    transform: "translate(-11.158 12.197)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.677,46.059,51.371,90.711l-1.144-1.946,26.3-44.653Z",
    transform: "translate(-11.866 13.087)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.673,49.053l-26.3,44.662-1.147-1.946L79.532,47.116Z",
    transform: "translate(-12.575 13.979)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.674,52.055l-26.3,44.652L56.226,94.77,82.533,50.117Z",
    transform: "translate(-13.284 14.869)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.675,55.058l-26.3,44.653-1.146-1.938,26.3-44.661Z",
    transform: "translate(-13.993 15.757)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.676,58.059,63.37,102.714l-1.143-1.95,26.3-44.653Z",
    transform: "translate(-14.702 16.648)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.674,61.055l-26.3,44.661-1.147-1.947L91.531,59.117Z",
    transform: "translate(-15.41 17.539)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.673,64.055l-26.3,44.652-1.148-1.937L94.533,62.116Z",
    transform: "translate(-16.119 18.429)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.675,67.057l-26.3,44.653-1.147-1.938,26.3-44.661Z",
    transform: "translate(-16.828 19.317)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.676,70.058,75.37,114.711l-1.143-1.948,26.3-44.652Z",
    transform: "translate(-17.537 20.208)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.672,73.054l-26.3,44.661-1.148-1.947,26.307-44.652Z",
    transform: "translate(-18.245 21.099)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.673,76.054l-26.3,44.654-1.147-1.938,26.307-44.652Z",
    transform: "translate(-18.954 21.989)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.675,79.057l-26.3,44.652-1.148-1.938,26.3-44.662Z",
    transform: "translate(-19.663 22.877)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.675,82.057,87.369,126.71l-1.143-1.947,26.3-44.652Z",
    transform: "translate(-20.371 23.768)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.672,85.053l-26.3,44.661-1.148-1.946,26.307-44.653Z",
    transform: "translate(-21.08 24.659)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.673,88.054l-26.3,44.662-1.146-1.948,26.307-44.653Z",
    transform: "translate(-21.789 25.549)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.674,91.055l-26.3,44.654-1.147-1.939,26.3-44.654Z",
    transform: "translate(-22.498 26.44)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.674,94.057,99.368,138.71l-1.143-1.937,26.3-44.662Z",
    transform: "translate(-23.206 27.328)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,663.915v.111H2.229l233.18-395.9-1.146-1.95Z",
    transform: "translate(0 78.972)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.917,663.136H8.212L239.1,271.13l-1.146-1.947Z",
    transform: "translate(-1.398 79.863)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.914,662.248h2.292l228.6-388.126-1.14-1.946Z",
    transform: "translate(-2.815 80.751)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.917,661.356h2.295L246.52,277.13l-1.147-1.95Z",
    transform: "translate(-4.233 81.642)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.917,660.466h2.29L250.226,280.13l-1.142-1.949Z",
    transform: "translate(-5.651 82.533)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.911,659.576h2.3L253.931,283.13l-1.147-1.949Z",
    transform: "translate(-7.067 83.423)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.916,658.687h2.292L257.646,286.126l-1.147-1.95Z",
    transform: "translate(-8.485 84.311)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.915,657.8h2.292L261.351,289.127l-1.14-1.947Z",
    transform: "translate(-9.903 85.202)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.916,656.906h2.291L265.06,292.131l-1.147-1.95Z",
    transform: "translate(-11.32 86.093)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.918,656.015h2.289L268.772,295.122l-1.146-1.94Z",
    transform: "translate(-12.739 86.983)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.911,655.126h2.3l210.27-357-1.147-1.95Z",
    transform: "translate(-14.154 87.872)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.918,654.236h2.29l207.98-353.11-1.143-1.947Z",
    transform: "translate(-15.573 88.762)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.59,515l-26.3-44.652-1.146,1.938,26.307,44.652Z",
    transform: "translate(-6.885 139.547)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.591,512l-26.3-44.652-1.148,1.947L58.45,513.947Z",
    transform: "translate(-7.594 138.656)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.592,509l-26.3-44.651L35.144,466.3l26.3,44.653Z",
    transform: "translate(-8.303 137.767)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.593,506.008,39.288,461.346l-1.145,1.947,26.3,44.653Z",
    transform: "translate(-9.012 136.875)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.59,503l-26.3-44.653L41.141,460.3l26.307,44.653Z",
    transform: "translate(-9.72 135.986)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.591,500.005l-26.3-44.654-1.147,1.937L70.45,501.951Z",
    transform: "translate(-10.429 135.097)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59,497l-26.3-44.653-1.148,1.947,26.3,44.653Z",
    transform: "translate(-11.138 134.205)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.591,494,51.286,449.349,50.144,451.3l26.3,44.653Z",
    transform: "translate(-11.847 133.316)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.59,491.005l-26.3-44.653-1.146,1.938,26.307,44.653Z",
    transform: "translate(-12.555 132.427)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.591,488l-26.3-44.653L56.142,445.3l26.307,44.652Z",
    transform: "translate(-13.264 131.535)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.592,485l-26.3-44.653L59.143,442.3l26.3,44.653Z",
    transform: "translate(-13.973 130.646)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.591,482.008,63.285,437.347l-1.142,1.946,26.3,44.652Z",
    transform: "translate(-14.682 129.755)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.589,479l-26.3-44.653L65.14,436.3,91.447,480.95Z",
    transform: "translate(-15.39 128.866)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,476l-26.3-44.652-1.147,1.937,26.308,44.662Z",
    transform: "translate(-16.099 127.977)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,473l-26.3-44.653L71.141,430.3l26.307,44.652Z",
    transform: "translate(-16.808 127.085)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.591,470l-26.3-44.653L74.143,427.3l26.3,44.653Z",
    transform: "translate(-17.517 126.196)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.589,467l-26.3-44.651-1.147,1.937,26.307,44.653Z",
    transform: "translate(-18.225 125.307)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,464l-26.3-44.655-1.148,1.95,26.307,44.654Z",
    transform: "translate(-18.934 124.415)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.589,461l-26.3-44.653-1.147,1.939,26.307,44.661Z",
    transform: "translate(-19.643 123.526)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.591,458.01l-26.3-44.662-1.147,1.946,26.3,44.653Z",
    transform: "translate(-20.352 122.635)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.592,455,90.286,410.351,89.144,412.3l26.3,44.653Z",
    transform: "translate(-21.061 121.746)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59,452.006l-26.3-44.654-1.148,1.938,26.307,44.661Z",
    transform: "translate(-21.769 120.856)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.589,449l-26.3-44.652L95.141,406.3l26.307,44.652Z",
    transform: "translate(-22.478 119.965)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,446l-26.3-44.653L98.142,403.3l26.3,44.652Z",
    transform: "translate(-23.187 119.076)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59,443.009l-26.306-44.662-1.142,1.947,26.3,44.652Z",
    transform: "translate(-23.895 118.184)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.587,440l-26.3-44.654-1.147,1.948,26.307,44.652Z",
    transform: "translate(-24.604 117.295)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.589,437l-26.3-44.652-1.147,1.937,26.307,44.662Z",
    transform: "translate(-25.313 116.406)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.59,434.01l-26.3-44.662-1.146,1.948,26.3,44.652Z",
    transform: "translate(-26.022 115.514)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.591,431l-26.305-44.654-1.143,1.948,26.3,44.653Z",
    transform: "translate(-26.731 114.625)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.591,428.007l-26.306-44.653-1.142,1.938,26.3,44.652Z",
    transform: "translate(-27.44 113.736)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.588,425l-26.3-44.653-1.148,1.947,26.306,44.653Z",
    transform: "translate(-28.148 112.845)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,422.005l-26.3-44.653-1.147,1.946,26.3,44.654Z",
    transform: "translate(-28.857 111.955)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,419.01l-26.305-44.662-1.144,1.947,26.3,44.652Z",
    transform: "translate(-29.565 111.064)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.59,416l-26.306-44.652-1.143,1.947,26.3,44.653Z",
    transform: "translate(-30.274 110.175)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.588,413.005l-26.3-44.651-1.146,1.937,26.307,44.653Z",
    transform: "translate(-30.983 109.286)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.589,410l-26.3-44.653-1.148,1.947,26.307,44.653Z",
    transform: "translate(-31.692 108.394)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.589,407l-26.305-44.652-1.143,1.947,26.3,44.652Z",
    transform: "translate(-32.4 107.505)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.587,404.008l-26.3-44.653-1.148,1.937,26.307,44.654Z",
    transform: "translate(-33.109 106.616)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.588,401l-26.3-44.652L143.14,358.3l26.307,44.654Z",
    transform: "translate(-33.818 105.725)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.589,398.006l-26.3-44.653-1.147,1.947,26.307,44.652Z",
    transform: "translate(-34.527 104.835)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.591,395.011l-26.307-44.661-1.141,1.946,26.3,44.653Z",
    transform: "translate(-35.236 103.944)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,392l-26.305-44.654-1.143,1.948,26.3,44.653Z",
    transform: "translate(-35.944 103.054)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.588,389.007l-26.3-44.653-1.148,1.938,26.306,44.662Z",
    transform: "translate(-36.653 102.165)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.589,386l-26.3-44.653-1.146,1.948,26.307,44.652Z",
    transform: "translate(-37.361 101.274)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.589,383.005l-26.3-44.652L161.14,340.3l26.3,44.653Z",
    transform: "translate(-38.07 100.385)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,380.008l-26.306-44.652-1.142,1.938,26.3,44.651Z",
    transform: "translate(-38.78 99.496)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.587,377l-26.3-44.653-1.146,1.948,26.307,44.652Z",
    transform: "translate(-39.488 98.604)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.589,374.006l-26.3-44.652L170.14,331.3l26.307,44.653Z",
    transform: "translate(-40.197 97.715)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.588,371l-26.3-44.653L173.14,328.3l26.3,44.653Z",
    transform: "translate(-40.905 96.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.589,368.006l-26.305-44.653-1.143,1.946,26.3,44.653Z",
    transform: "translate(-41.615 95.934)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.587,365.008l-26.3-44.653-1.146,1.938,26.307,44.653Z",
    transform: "translate(-42.323 95.045)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.587,362l-26.3-44.653-1.148,1.947,26.307,44.654Z",
    transform: "translate(-43.031 94.154)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588,359.006l-26.3-44.652L185.14,316.3l26.3,44.654Z",
    transform: "translate(-43.74 93.265)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.589,356.012l-26.305-44.662-1.143,1.947,26.3,44.652Z",
    transform: "translate(-44.449 92.373)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.585,353l-26.3-44.652-1.146,1.946,26.306,44.653Z",
    transform: "translate(-45.157 91.484)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.587,350.008l-26.3-44.654-1.147,1.938,26.307,44.662Z",
    transform: "translate(-45.866 90.595)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.587,347l-26.3-44.652-1.149,1.947,26.3,44.653Z",
    transform: "translate(-46.575 89.703)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,569.735l.392.666,1.14-1.95L0,565.85Z",
    transform: "translate(0 167.88)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,563.738l2.683,4.556,1.142-1.947L0,559.851Z",
    transform: "translate(0 166.1)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,557.742l4.97,8.438,1.146-1.948L0,553.845Z",
    transform: "translate(0 164.318)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,551.744,7.263,564.07l1.148-1.947L0,547.849Z",
    transform: "translate(0 162.539)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,545.733l9.556,16.223,1.143-1.941L0,541.854Z",
    transform: "translate(0 160.761)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,539.74,11.85,559.851l1.141-1.949L0,535.848Z",
    transform: "translate(0 158.979)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,533.748l14.135,24,1.147-1.949L0,529.85Z",
    transform: "translate(0 157.199)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,527.74l16.427,27.889,1.147-1.939L0,523.848Z",
    transform: "translate(0 155.419)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,521.742,18.72,553.52l1.147-1.95L0,517.853Z",
    transform: "translate(0 153.64)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,515.738l21.012,35.668,1.143-1.94L0,511.851Z",
    transform: "translate(0 151.859)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,509.742l23.3,39.56,1.142-1.95L0,505.847Z",
    transform: "translate(0 150.078)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,501.166v2.41l25.59,43.447,1.148-1.947L.44,500.422Z",
    transform: "translate(0 148.469)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.52,542.078,3.214,497.426l-1.143,1.938,26.3,44.653Z",
    transform: "translate(-0.489 147.579)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.517,539.074l-26.3-44.653-1.148,1.948,26.307,44.652Z",
    transform: "translate(-1.198 146.688)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.518,536.076l-26.3-44.652-1.147,1.947,26.308,44.652Z",
    transform: "translate(-1.906 145.799)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.519,533.081l-26.3-44.662-1.146,1.947,26.3,44.653Z",
    transform: "translate(-2.615 144.907)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52,530.075,15.214,485.422l-1.143,1.948,26.3,44.651Z",
    transform: "translate(-3.324 144.018)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.517,527.078l-26.3-44.652-1.148,1.937,26.307,44.653Z",
    transform: "translate(-4.033 143.129)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.517,524.074l-26.3-44.653-1.148,1.948,26.307,44.652Z",
    transform: "translate(-4.741 142.238)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.518,521.076l-26.3-44.653-1.146,1.947,26.3,44.654Z",
    transform: "translate(-5.45 141.348)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.519,518.081,27.214,473.419l-1.143,1.947,26.3,44.652Z",
    transform: "translate(-6.159 140.457)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,101.607l179.156,304.17,1.147-1.947L0,97.71Z",
    transform: "translate(0 28.989)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,95.6,181.447,403.659l1.146-1.938L0,91.715Z",
    transform: "translate(0 27.211)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,89.606,183.741,401.562l1.148-1.954L0,85.71Z",
    transform: "translate(0 25.429)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,83.611,186.03,399.452l1.147-1.948L0,79.712Z",
    transform: "translate(0 23.649)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,77.6,188.324,397.336l1.143-1.937L0,73.72Z",
    transform: "translate(0 21.872)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,71.611,190.613,395.236l1.148-1.956L0,67.709Z",
    transform: "translate(0 20.088)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,65.605,192.9,393.119l1.147-1.95L0,61.714Z",
    transform: "translate(0 18.31)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,59.6,195.2,391l1.148-1.938L0,55.713Z",
    transform: "translate(0 16.529)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,53.607,197.486,388.9l1.148-1.947L0,49.711Z",
    transform: "translate(0 14.749)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,47.6,199.777,386.78l1.147-1.939L0,43.714Z",
    transform: "translate(0 12.969)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,41.607,202.07,384.68l1.148-1.95L0,37.711Z",
    transform: "translate(0 11.188)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,35.6,204.366,382.569l1.143-1.948L0,31.713Z",
    transform: "translate(0 9.409)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,104.87l1.048-1.78L0,101.318Z",
    transform: "translate(0 30.06)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,107.91V111.8L3.34,106.13,2.2,104.184Z",
    transform: "translate(0 30.91)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,114.8v3.88l5.629-9.557-1.143-1.938Z",
    transform: "translate(0 31.801)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,121.688v3.892l7.921-13.453-1.148-1.938Z",
    transform: "translate(0 32.692)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,128.581v3.887l10.213-17.339-1.147-1.94Z",
    transform: "translate(0 33.581)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,135.468v3.887l12.5-21.226-1.141-1.946Z",
    transform: "translate(0 34.47)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,142.358v3.89L14.8,121.131l-1.143-1.947Z",
    transform: "translate(0 35.36)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,149.252v3.89l17.085-29.015-1.141-1.938Z",
    transform: "translate(0 36.252)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,156.139v3.887l19.376-32.9-1.147-1.937Z",
    transform: "translate(0 37.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,163.032v3.876l21.67-36.78-1.148-1.938Z",
    transform: "translate(0 38.032)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,169.915v3.894L23.96,133.129l-1.141-1.946Z",
    transform: "translate(0 38.92)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,176.807v3.9l26.25-44.58-1.143-1.939Z",
    transform: "translate(0 39.812)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.881,139.127l-26.3,44.654-1.147-1.94L27.74,137.19Z",
    transform: "translate(-0.338 40.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.883,142.13,5.577,186.783l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-1.048 41.59)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,145.13l-26.3,44.654-1.146-1.95,26.307-44.652Z",
    transform: "translate(-1.756 42.481)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.88,148.126l-26.3,44.662-1.146-1.947,26.307-44.654Z",
    transform: "translate(-2.464 43.372)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.881,151.127l-26.3,44.654-1.147-1.94,26.3-44.653Z",
    transform: "translate(-3.173 44.262)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.882,154.126,17.576,198.78l-1.143-1.938,26.3-44.653Z",
    transform: "translate(-3.883 45.153)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,157.131l-26.3,44.653-1.148-1.938,26.308-44.662Z",
    transform: "translate(-4.591 46.041)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.88,160.125l-26.3,44.662-1.147-1.946,26.307-44.653Z",
    transform: "translate(-5.299 46.932)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88,163.125l-26.3,44.653-1.147-1.938,26.307-44.653Z",
    transform: "translate(-6.008 47.822)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.882,166.128,29.576,210.783l-1.143-1.94,26.3-44.662Z",
    transform: "translate(-6.718 48.71)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.878,169.129l-26.3,44.653-1.15-1.938,26.307-44.662Z",
    transform: "translate(-7.425 49.601)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.879,172.124l-26.3,44.661-1.147-1.946,26.307-44.652Z",
    transform: "translate(-8.134 50.492)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,175.125l-26.3,44.662-1.147-1.947,26.307-44.652Z",
    transform: "translate(-8.844 51.383)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.881,178.129,41.575,222.781l-1.144-1.938,26.3-44.662Z",
    transform: "translate(-9.552 52.271)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.881,181.128,44.575,225.781l-1.143-1.938,26.3-44.661Z",
    transform: "translate(-10.261 53.161)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.879,184.125l-26.3,44.661-1.148-1.947,26.307-44.654Z",
    transform: "translate(-10.97 54.052)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,187.125l-26.3,44.661-1.146-1.947,26.307-44.653Z",
    transform: "translate(-11.679 54.942)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.881,190.125,53.575,234.778l-1.143-1.937,26.3-44.654Z",
    transform: "translate(-12.388 55.833)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.878,193.129l-26.3,44.653-1.146-1.938,26.307-44.662Z",
    transform: "translate(-13.095 56.721)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.878,196.129l-26.3,44.653-1.147-1.947,26.308-44.653Z",
    transform: "translate(-13.804 57.611)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,199.124l-26.3,44.661-1.146-1.947,26.307-44.651Z",
    transform: "translate(-14.514 58.503)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.881,202.125l-26.3,44.653-1.147-1.938,26.3-44.653Z",
    transform: "translate(-15.223 59.393)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.88,205.128,68.575,249.78l-1.143-1.937,26.3-44.662Z",
    transform: "translate(-15.931 60.281)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.878,208.129l-26.3,44.653-1.147-1.948,26.307-44.651Z",
    transform: "translate(-16.639 61.172)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,211.124l-26.3,44.662-1.148-1.947,26.307-44.653Z",
    transform: "translate(-17.349 62.063)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.879,214.125l-26.3,44.652-1.146-1.937,26.3-44.653Z",
    transform: "translate(-18.057 62.953)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,217.128,80.574,261.78l-1.143-1.938,26.3-44.662Z",
    transform: "translate(-18.766 63.841)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.877,220.128l-26.3,44.653-1.147-1.947,26.307-44.652Z",
    transform: "translate(-19.474 64.731)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.879,223.124l-26.3,44.662-1.147-1.947,26.307-44.653Z",
    transform: "translate(-20.184 65.623)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.878,226.125l-26.3,44.653L88.43,268.84l26.3-44.653Z",
    transform: "translate(-20.892 66.513)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,229.125,92.574,273.778l-1.143-1.938,26.3-44.652Z",
    transform: "translate(-21.601 67.404)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.877,232.127l-26.3,44.653-1.148-1.938,26.307-44.662Z",
    transform: "translate(-22.309 68.291)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.877,235.122l-26.3,44.662-1.147-1.947,26.308-44.652Z",
    transform: "translate(-23.018 69.183)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878,238.124l-26.3,44.653-1.148-1.939,26.307-44.653Z",
    transform: "translate(-23.727 70.073)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.879,241.125l-26.305,44.651-1.143-1.937,26.3-44.652Z",
    transform: "translate(-24.436 70.964)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.877,244.127l-26.3,44.653-1.147-1.937,26.307-44.662Z",
    transform: "translate(-25.145 71.852)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.879,247.129l-26.3,44.652-1.148-1.947,26.307-44.653Z",
    transform: "translate(-25.854 72.742)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.878,250.124l-26.3,44.662-1.146-1.948,26.307-44.653Z",
    transform: "translate(-26.562 73.633)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.879,253.124l-26.3,44.652-1.148-1.938,26.3-44.652Z",
    transform: "translate(-27.271 74.524)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.88,256.127l-26.305,44.662-1.143-1.946,26.3-44.662Z",
    transform: "translate(-27.98 75.412)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.876,259.128l-26.3,44.653-1.148-1.946,26.307-44.654Z",
    transform: "translate(-28.688 76.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.877,262.123l-26.3,44.653-1.147-1.938,26.307-44.652Z",
    transform: "translate(-29.397 77.194)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.879,265.124l-26.306,44.662-1.143-1.947,26.3-44.653Z",
    transform: "translate(-30.106 78.084)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,479.961v3.894L127.067,268.123l-1.153-1.939Z",
    transform: "translate(0 78.973)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,486.851v3.9L129.354,271.131l-1.146-1.948Z",
    transform: "translate(0 79.863)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,493.739v3.89L131.644,274.122l-1.141-1.946Z",
    transform: "translate(0 80.751)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,500.633v3.891l133.937-227.4-1.147-1.947Z",
    transform: "translate(0 81.642)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,507.522v3.892L136.233,280.123l-1.151-1.94Z",
    transform: "translate(0 82.533)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,514.406v3.9L138.517,283.13l-1.146-1.947Z",
    transform: "translate(0 83.423)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,521.3v3.891l140.81-239.069-1.147-1.947Z",
    transform: "translate(0 84.311)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,528.188v3.894l143.1-242.961-1.153-1.94Z",
    transform: "translate(0 85.203)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,535.078v3.9L145.4,292.128l-1.153-1.947Z",
    transform: "translate(0 86.093)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,541.972v3.887L147.685,295.121l-1.147-1.938Z",
    transform: "translate(0 86.984)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,548.86v3.9L149.973,298.134l-1.141-1.96Z",
    transform: "translate(0 87.871)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,555.75v3.891L152.269,301.121l-1.153-1.94Z",
    transform: "translate(0 88.763)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,428.724l.928-1.576L0,425.574Z",
    transform: "translate(0 126.262)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,423.463l2.072,3.518,1.148-1.939L0,419.576Z",
    transform: "translate(0 124.483)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,417.463l4.366,7.412,1.143-1.95L0,413.574Z",
    transform: "translate(0 122.702)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,411.457l6.659,11.3,1.141-1.94L0,407.576Z",
    transform: "translate(0 120.922)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,405.46l8.95,15.193,1.141-1.947L0,401.576Z",
    transform: "translate(0 119.142)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,399.468,11.24,418.547l1.147-1.95L0,395.578Z",
    transform: "translate(0 117.363)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,393.462l13.531,22.969,1.141-1.94L0,389.574Z",
    transform: "translate(0 115.582)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,387.465l15.823,26.859,1.143-1.947L0,383.573Z",
    transform: "translate(0 113.801)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,381.459l18.114,30.747,1.143-1.935L0,377.576Z",
    transform: "translate(0 112.022)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,375.467,20.4,410.1l1.147-1.949L0,371.572Z",
    transform: "translate(0 110.241)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,369.469,22.695,408l1.147-1.95L0,365.579Z",
    transform: "translate(0 108.462)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,363.466,24.99,405.882l1.141-1.94L0,359.579Z",
    transform: "translate(0 106.682)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.723,401l-26.3-44.652L1.274,358.3l26.307,44.654Z",
    transform: "translate(-0.301 105.725)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.725,398.006l-26.3-44.653L4.276,355.3l26.3,44.652Z",
    transform: "translate(-1.01 104.835)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.726,395.011,8.42,350.349,7.277,352.3l26.3,44.653Z",
    transform: "translate(-1.719 103.944)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.722,392l-26.3-44.654L10.273,349.3,36.58,393.951Z",
    transform: "translate(-2.427 103.054)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.723,389.007l-26.3-44.653-1.147,1.938,26.307,44.662Z",
    transform: "translate(-3.136 102.165)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.724,386l-26.3-44.653L16.275,343.3l26.3,44.652Z",
    transform: "translate(-3.845 101.274)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.725,383.005,20.42,338.353,19.276,340.3l26.3,44.653Z",
    transform: "translate(-4.554 100.385)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723,380.008l-26.3-44.652-1.146,1.938,26.308,44.651Z",
    transform: "translate(-5.262 99.496)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.723,377l-26.3-44.653L25.274,334.3l26.307,44.652Z",
    transform: "translate(-5.971 98.604)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.724,374.006l-26.3-44.652L28.276,331.3l26.3,44.653Z",
    transform: "translate(-6.68 97.715)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.723,371,32.417,326.35,31.275,328.3l26.3,44.653Z",
    transform: "translate(-7.389 96.824)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.721,368.006l-26.3-44.653L34.272,325.3,60.58,369.952Z",
    transform: "translate(-8.097 95.934)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.722,365.008l-26.3-44.653-1.148,1.938,26.307,44.653Z",
    transform: "translate(-8.806 95.045)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.724,362l-26.3-44.653L40.275,319.3l26.3,44.654Z",
    transform: "translate(-9.515 94.154)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.725,359.006,44.419,314.354,43.277,316.3l26.3,44.654Z",
    transform: "translate(-10.224 93.265)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.721,356.012l-26.3-44.662L46.272,313.3,72.58,357.948Z",
    transform: "translate(-10.932 92.373)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.722,353l-26.3-44.652L49.274,310.3,75.58,354.952Z",
    transform: "translate(-11.641 91.484)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.723,350.008l-26.3-44.654-1.148,1.938,26.3,44.662Z",
    transform: "translate(-12.35 90.595)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.723,347,56.417,302.351,55.274,304.3l26.3,44.653Z",
    transform: "translate(-13.059 89.703)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,243.464,70.814,363.689l1.143-1.95L0,239.578Z",
    transform: "translate(0 71.08)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,237.466l73.1,124.1,1.146-1.931L0,233.585Z",
    transform: "translate(0 69.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,231.469l75.389,128,1.148-1.947L0,227.574Z",
    transform: "translate(0 67.518)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,225.467,77.686,357.36l1.143-1.947L0,221.58Z",
    transform: "translate(0 65.74)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,219.474,79.97,355.248l1.154-1.938L0,215.58Z",
    transform: "translate(0 63.96)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,213.473,82.265,353.14l1.148-1.947L0,209.576Z",
    transform: "translate(0 62.178)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,207.472,84.554,351.029l1.147-1.947L0,203.581Z",
    transform: "translate(0 60.4)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,201.469,86.848,348.92,88,346.97,0,197.575Z",
    transform: "translate(0 58.618)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,195.473,89.139,346.811l1.151-1.95L0,191.572Z",
    transform: "translate(0 56.837)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,189.465,91.427,344.688l1.148-1.928L0,185.586Z",
    transform: "translate(0 55.061)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,183.467l93.72,159.119,1.148-1.94L0,179.58Z",
    transform: "translate(0 53.279)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,177.471l96.01,163.006,1.146-1.949L0,173.575Z",
    transform: "translate(0 51.497)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,244.483l.383-.65L0,243.179Z",
    transform: "translate(0 72.148)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,247.777v3.894l2.676-4.541-1.147-1.95Z",
    transform: "translate(0 72.742)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,254.669v3.889l4.967-8.436-1.148-1.938Z",
    transform: "translate(0 73.633)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,261.561v3.885L7.26,253.123l-1.147-1.938Z",
    transform: "translate(0 74.523)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,268.451v3.89l9.548-16.212L8.408,254.18Z",
    transform: "translate(0 75.412)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,275.34v3.89l11.84-20.1L10.7,257.181Z",
    transform: "translate(0 76.302)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,282.23v3.887l14.131-23.994-1.146-1.94Z",
    transform: "translate(0 77.193)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,289.121v3.888l16.422-27.885-1.147-1.938Z",
    transform: "translate(0 78.084)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,296.01V299.9L18.711,268.13l-1.141-1.946Z",
    transform: "translate(0 78.973)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,302.9v3.886l21-35.661-1.143-1.95Z",
    transform: "translate(0 79.861)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,309.784v3.887L23.3,274.122l-1.143-1.947Z",
    transform: "translate(0 80.751)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,316.675v3.894l25.589-43.444-1.147-1.948Z",
    transform: "translate(0 81.641)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,323.574v3.878l27.877-47.33-1.141-1.937Z",
    transform: "translate(0 82.534)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,330.458v3.888l30.166-51.218-1.142-1.946Z",
    transform: "translate(0 83.423)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,337.347v3.886l32.461-55.113-1.147-1.94Z",
    transform: "translate(0 84.313)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,344.237v3.894l34.756-59.007-1.148-1.946Z",
    transform: "translate(0 85.202)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,351.129v3.88l37.039-62.887-1.141-1.94Z",
    transform: "translate(0 86.093)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,358.017V361.9l39.334-66.783-1.147-1.938Z",
    transform: "translate(0 86.984)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,364.9v3.9l41.623-70.669-1.143-1.956Z",
    transform: "translate(0 87.871)",
    fill: "#1b3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,371.8v3.893L43.92,301.125l-1.147-1.95Z",
    transform: "translate(0 88.761)",
    fill: "#1b3281"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPatternBg);
export default __webpack_public_path__ + "static/media/Login-Pattern-BG.fa0f1e3515bd08cb93685bc59d9b7115.svg";
export { ForwardRef as ReactComponent };